export const SHAPES_SVG = [
  {
    id: "shape1",
    selectedpalate: 0,
    data: [
      {
        fill: "#ff0000",
        id: "shape1-1",
        d: `M399.953,199.979v-0.002c0-110.441-89.531-199.98-199.978-199.98C89.531-0.003,0,89.536,0,199.977v0.002
         H399.953z`,
      },
      {
        fill: "#6F8DA3",
        id: "shape1-2",
        d: `M0,199.979c0.002,110.446,89.53,199.979,199.975,199.979c110.447,0,199.978-89.532,199.978-199.979H0z`,
      },
      {
        fill: "#FFFFFF",
        id: "shape1-3",
        d: `M200.165,381.506C99.906,381.604,18.56,300.433,18.446,200.173C18.347,99.909,99.519,18.562,199.78,18.451
                    c100.261-0.1,181.625,81.073,181.722,181.333C381.606,300.05,300.426,381.4,200.165,381.506z`,
      },
    ],
    palette: [
      ["#FF0000", "#6F8DA3", "#FFFFFF"], // Red, Slate Blue, White
      ["#00FF00", "#0000FF", "#FFFFFF"], // Green, Blue, White
      ["#FF9900", "#9900FF", "#FFFFFF"], // Orange, Purple, White
      ["#1E90FF", "#FF4500", "#FFFFFF"], // Dodger Blue, Orange Red, White
    ],
  },
  {
    id: "shape2",
    selectedpalate: 0,
    data: [
      {
        fill: "#D6E1F1",
        id: "shape2-1",
        d: `M361.699,341.677c0,1.367,0,4.993-5.436,6.489l-146.406,41.693c-4.02,1.146-6.762,1.612-9.46,1.612
                 c-2.742,0-5.854-0.493-10.372-1.644L43.733,348.162c-4.905-1.395-5.434-4.998-5.434-6.485V221.144h323.399V341.677z`,
      },
      {
        fill: "#242956",
        id: "shape2-2",
        d: `M29.771,341.677c0,4.813,2.626,12.126,11.627,14.69l146.405,41.693c5.07,1.299,8.907,1.939,12.594,1.939
                 c3.72,0,7.28-0.652,11.798-1.939l146.407-41.693c6.623-1.823,11.625-6.767,11.625-14.69V91.009h-0.018
                 c0-23.142-5.66-27.189-20.627-32.179c-10.004-3.334-43.09-12.898-64.471-19.025V0H114.883v39.805
                 C93.508,45.932,60.42,55.496,50.416,58.83c-14.972,4.99-20.631,10.458-20.631,32.179h-0.014V341.677z M361.699,322.217
                 c0,1.367,0,4.991-5.436,6.487l-146.406,41.695c-4.02,1.145-6.762,1.61-9.46,1.61c-2.742,0-5.854-0.491-10.372-1.644L43.733,328.702
                 c-4.905-1.396-5.434-5-5.434-6.485V221.144h323.399V322.217z M356.264,348.166l-146.406,41.693c-4.02,1.146-6.762,1.612-9.46,1.612
                 c-2.742,0-5.854-0.493-10.372-1.644L43.733,348.162c-4.905-1.395-5.434-4.998-5.434-6.485v-5.952
                 c0.938,0.459,1.965,0.857,3.099,1.181l146.405,41.695c5.07,1.298,8.907,1.938,12.594,1.938c3.72,0,7.278-0.652,11.798-1.938
                 l146.407-41.695c1.089-0.299,2.11-0.717,3.097-1.183v5.954C361.699,343.044,361.699,346.67,356.264,348.166z`,
      },
    ],
    palette: [
      ["#D6E1F1", "#242956"], // Red, Slate Blue, White
      ["#00FF00", "#FFFFFF"], // Green, Blue, White
      ["#FF9900", "#FFFFFF"], // Orange, Purple, White
      ["#1E90FF", "#FFFFFF"], // Dodger Blue, Orange Red, White
    ],
  },
  {
    id: "shape3",
    selectedpalate: 0,
    data: [
      {
        fill: "#E54C42",
        id: "shape3-1",
        d: `M 200.002,397.744 L 371.416,298.781 L 371.416,100.85 L 200.002,1.886 Z`,
      },
      {
        fill: "#C63130",
        id: "shape3-2",
        d: `M 200,1.884 L 28.588,100.85 L 28.588,298.781 L 200,397.744 L 200.002,397.744 L 200.002,1.886 Z`,
      },
      {
        fill: "#FFFFFF",
        id: "shape3-3",
        d: `M 200.002,195.324 m -121.052, 0 a 121.052,121.052 0 1,0 242.104,0 a 121.052,121.052 0 1,0 -242.104,0`,
      },
      {
        fill: "#9B3535",
        id: "shape3-4",
        d: `M200.06,400h-0.012c-4.299,0-8.429-2.431-8.891-2.711l-3.749-2.022L34.024,306.559
                c-1.067-0.508-4.702-2.453-6.948-6.35c-2.468-4.8-2.321-10.839-2.295-11.51l-0.074-13.298l-0.091-166.303
                c-0.096-1.172-0.228-5.296,2.025-9.195c2.146-3.722,6.325-6.085,6.792-6.344l3.631-2.236L190.58,2.844
                C191.55,2.178,195.054,0,199.553,0c4.296,0,8.435,2.438,8.893,2.716l13.707,7.618l144.105,83.098
                c1.063,0.502,4.706,2.447,6.953,6.35c2.15,3.721,2.106,8.519,2.092,9.052l0.123,4.265l-0.13,177.186
                c0.093,1.176,0.228,5.301-2.019,9.19c-2.154,3.726-6.334,6.088-6.806,6.347l-13.425,8.081L209.024,397.16
                C208.056,397.821,204.557,400,200.06,400z M199.553,8.019c-2.356,0-4.396,1.411-4.415,1.425l-0.394,0.258L41.167,98.218
                l-3.703,2.277c-0.847,0.476-3.007,1.913-3.875,3.418c-1.181,2.039-0.981,4.513-0.978,4.535l0.026,0.462l0.089,166.467l0.072,13.448
                c-0.042,1.42,0.117,5.202,1.319,7.549c1.1,1.896,3.356,2.942,3.377,2.953l0.387,0.192l153.445,88.751l3.82,2.063
                c0.838,0.49,3.159,1.645,4.901,1.645h0.012c2.347,0,4.388-1.406,4.403-1.42l0.39-0.26l144.122-83.307l13.509-8.127
                c0.816-0.458,2.974-1.893,3.849-3.4c1.173-2.036,0.974-4.51,0.969-4.534l-0.026-0.469l0.131-177.259l-0.12-4.349
                c0.01-0.973-0.15-3.56-1.025-5.067c-1.189-2.069-3.445-3.114-3.471-3.121l-0.379-0.195L218.199,17.313L204.41,9.648
                C203.612,9.174,201.293,8.019,199.553,8.019z`,
      },
    ],
    palette: [
      ["#E54C42", "#C63130", "#FFFFFF", "#9B3535"],
      ["#00FF00", "#0000FF", "#FFFFFF", "#FFFF00"],
      ["#FF9900", "#800080", "#FFFFFF", "#00FFFF"],
      ["#1E90FF", "#FF4500", "#FFFFFF", "#808080"],
    ],
  },
  {
    id: "shape4",
    selectedpalate: 0,
    data: [
      {
        fill: "#E54C42",
        id: "shape4-1",
        d: `M29.953,64.268l170.128-51.95l169.01,36.65c0,0,18.017,157.198,1.019,207.561
            c-16.993,50.363-119.541,125.965-170.032,125.965c-50.492,0-169.614-63.266-169.614-135.145
            C30.463,175.475,29.953,64.268,29.953,64.268z`,
      },
      {
        fill: "#C63130",
        id: "shape4-2",
        d: `M200.075,387.945l-51.95-19.137v-0.338c-27.678-12.365-52.777-28.162-72.838-45.881
            c-31.483-27.805-48.818-58.822-48.818-87.336V72.439l0.55-0.233c1.728-7.79,7.62-14.04,15.463-16.159l0.146-0.125l2.091-0.394
            c51.44-9.092,113.178-29.843,145.401-41.402c3.324-1.2,6.681-1.809,9.962-1.809c3.28,0,6.536,0.588,9.942,1.805
            c32.282,11.577,94.096,32.353,145.549,41.429l2.207,0.391l0.167,0.153c8.485,2.385,14.797,9.747,15.699,18.678l0.04,0.78v159.7
            c0,28.514-17.338,59.531-48.814,87.336c-21.194,18.719-48.014,35.299-77.557,47.936l-0.37,0.15L200.075,387.945z M158.858,356.199
            l41.217,15.18l41.309-15.215c27.964-11.992,53.272-27.623,73.198-45.227c28.093-24.809,43.562-51.688,43.562-75.684V76.027
            c-0.401-2.623-2.465-4.708-5.116-5.124l-2.91-0.461l-0.076-0.091c-51.99-9.519-113.103-30.061-145.248-41.594
            c-3.447-1.229-6.093-1.205-9.407-0.005c-32.122,11.52-93.171,32.043-145.145,41.575l-0.086,0.103l-2.921,0.474
            c-2.97,0.468-5.138,2.962-5.193,5.956l0.138,3.352l-0.168,0.204v154.84c0,23.996,15.474,50.875,43.563,75.684
            C105.521,328.557,130.861,344.207,158.858,356.199z`,
      },
      {
        fill: "#FFFFFF",
        id: "shape4-3",
        d: `M385.849,59.964c-0.286-5.966-5.014-10.756-10.954-11.135l-0.016-0.015
            C318.94,36.729,253.485,16.637,216.375,3.193c-0.002-0.002-0.005-0.002-0.008-0.003c-12.072-4.307-22.171-4.199-32.583,0h-0.003
            C146.677,16.633,79.612,40.119,25.118,48.814l-0.014,0.015c-5.94,0.379-10.668,5.169-10.953,11.135l-0.028,0.03
            c0,0,0,94.949,0,175.278c0,74.807,102.636,147.223,182.002,164.041v-0.002c0.04,0.012,0.081,0.018,0.121,0.029
            c0.546,0.191,1.113,0.348,1.695,0.453c0.09,0.018,0.177,0.027,0.262,0.041c0.593,0.096,1.196,0.16,1.812,0.164
            c0.017,0,0.03,0.002,0.042,0.002c0.009,0,0.013,0,0.021,0c0.002,0,0.012,0,0.014,0c0.017,0,0.027-0.002,0.042-0.002
            c0.618-0.004,1.221-0.068,1.813-0.164c0.088-0.014,0.177-0.023,0.261-0.041c0.584-0.105,1.151-0.262,1.7-0.453
            c0.039-0.012,0.082-0.018,0.119-0.029v0.002c109.588-32.959,181.851-95.738,181.851-164.041c0-80.329,0-175.278,0-175.278
            L385.849,59.964z M365.912,235.271c0,26.254-16.4,55.201-46.189,81.512c-20.848,18.414-46.73,34.322-75.467,46.619l-44.183,16.275
            l-44.179-16.27v-0.006c-28.734-12.297-54.62-28.205-75.468-46.619c-29.785-26.311-46.188-55.258-46.188-81.512V77.615l0.047-0.021
            l0.013-0.013c-0.008-0.197-0.03-0.388-0.03-0.588c0-6.952,5.098-12.698,11.754-13.749l0.01-0.012l0.04-0.033
            C97.298,54.144,158.063,33.9,192.74,21.46h0.002c5.783-2.089,10.465-1.5,14.668,0h0.004c34.711,12.452,95.551,32.719,146.806,41.762
            l0.005,0.009l0.012,0.012c6.2,0.979,11.038,6.027,11.676,12.329V235.271z`,
      },
    ],
    palette: [
      ["#E54C42", "#C63130", "#FFFFFF"],
      ["#00FF00", "#0000FF", "#FFFFFF"],
      ["#FF9900", "#800080", "#FFFFFF"],
      ["#1E90FF", "#FF4500", "#FFFFFF"],
    ],
  },
  {
    id: "shape5",
    selectedpalate: 0,
    data: [
      {
        fill: "#EFC562",
        id: "shape5-1",
        d: `M382.4,38.1c-31.7,0-63.3-3.9-94-11.6c-29-7.3-58.7-10.9-88.4-10.9c-29.7,0-59.3,3.6-88.3,10.9
             c-15.4,3.9-31,6.7-46.7,8.7c-15.7,1.9-31.5,2.9-47.4,2.9C7.8,38.1,0,46.1,0,55.7c0,0.6,0,1.2,0.1,1.9l30.4,288.6
             c0.8,7.1,5.7,13,12.5,15c51.2,15.4,104.1,23,157,23c52.9,0,105.8-7.7,157.1-23c3.4-1,6.3-3,8.5-5.6c2.2-2.6,3.6-5.9,4-9.4
             l30.4-288.6C401,47.2,392.8,38.1,382.4,38.1z`,
      },
      {
        fill: "#F0EFD3",
        id: "shape5-2",
        d: `M363.3,55.1c-28.4,0-56.6-3.5-84.1-10.4C253.2,38.3,226.6,35,200,35c-26.6,0-53.1,3.3-79.1,9.7
             c-13.8,3.4-27.7,6-41.8,7.8c-14,1.7-28.2,2.6-42.4,2.6C28,55.1,21,62.3,21,70.9c0,0.6,0,1.1,0.1,1.7l27.2,258.3
             c0.7,6.3,5.1,11.6,11.2,13.5C105.3,358.1,152.6,365,200,365c47.4,0,94.7-6.9,140.6-20.6c3-0.9,5.7-2.7,7.6-5c2-2.4,3.2-5.3,3.5-8.4
             L379,72.6C379.9,63.2,372.6,55.1,363.3,55.1z`,
      },
    ],
    palette: [
      ["#EFC562", "#F0EFD3"],
      ["#00FF00", "#0000FF"],
      ["#FF9900", "#800080"],
      ["#1E90FF", "#FF4500"],
    ],
  },
  {
    id: "shape6",
    selectedpalate: 0,
    data: [
      {
        fill: "#EFC562",
        id: "shape6-1",
        d: `M200,0c-41.3,0-82.6,3.4-123.4,10.3C76.6,46.6,47.2,76,10.9,76v52v144v50.9c18.1,0,34.6,7.4,46.5,19.3
             s19.3,28.3,19.3,46.5c40.8,7.6,82.1,11.5,123.4,11.5s82.6-3.8,123.4-11.5c0-36.3,29.4-65.7,65.7-65.7v-51V128V76
             c-18.1,0-34.6-7.3-46.5-19.3c-11.9-11.9-19.3-28.3-19.3-46.5C282.6,3.4,241.3,0,200,0L200,0z`,
      },
      {
        fill: "#F0EFD3",
        id: "shape6-2",
        d: `M305.4,27.4c-34.9-5.1-70.3-7.7-105.4-7.7s-70.5,2.6-105.5,7.7c-6.6,32.5-31.8,58.4-64,66V128v144v33.4
             c15.3,3.6,29.3,11.4,40.7,22.8c12.1,12.1,20.1,27.1,23.4,43.5c34.8,5.7,70.2,8.6,105.4,8.6s70.5-2.9,105.4-8.6
             c6.6-32.6,31.8-58.6,64-66.3V272V128V93.4c-15.3-3.6-29.3-11.4-40.7-22.8C316.7,58.7,308.7,43.7,305.4,27.4z`,
      },
      {
        fill: "#7DACC7",
        id: "shape6-3",
        d: `M30.6,126.1v2v142.4c112.8-8.7,226.1-8.7,338.9,0V128v-2C256.7,115.3,143.3,115.3,30.6,126.1z`,
      },
    ],
    palette: [
      ["#EFC562", "#F0EFD3", "#7DACC7"], // Red, Slate Blue, Gold
      ["#00FF00", "#0000FF", "#FF69B4"], // Green, Blue, Hot Pink
      ["#FF9900", "#800080", "#008080"], // Orange, Purple, Teal
      ["#1E90FF", "#FF4500", "#32CD32"], // Dodger Blue, Orange Red, Lime Green
    ],
  },
  {
    id: "shape7",
    selectedpalate: 0,
    data: [
      {
        fill: "#C2433C",
        id: "shape7-1",
        d: `M200,400C41.7,355.8,30.2,268.9,30.2,81.9c0-13.8,0.6-27.4,1.9-40.8C84,14.6,140.7,0,200,0s116,14.6,167.9,41.1
            c1.3,13.4,1.9,27,1.9,40.8C369.8,268.9,358.3,355.8,200,400z`,
      },
      {
        fill: "#F0EFD3",
        id: "shape7-2",
        d: `M48.3,108.9C96,93.1,147,84.6,200,84.6c53,0,103.9,8.5,151.6,24.2c0-5.2,0-10.5,0-15.9
            c0-12.3-0.6-24.5-1.7-36.4c-46.4-23.7-97-36.7-150-36.7S96.4,32.8,50,56.5c-1.1,12-1.7,24.1-1.7,36.4
            C48.3,98.3,48.3,103.6,48.3,108.9`,
      },
      {
        fill: "#E0BCBC",
        id: "shape7-3",
        d: `M351.7,121.1c-48.2-15.4-99.6-23.7-152.9-23.7c-52.4,0-103,8-150.5,22.9l0,0l0,0c0,0-0.1,0-0.1,0h0.1
            C49.7,269.9,65.9,341.6,200,379C333.8,341.7,350.3,270.2,351.7,121.1L351.7,121.1L351.7,121.1z`,
      },
    ],
    palette: [
      ["#C2433C", "#F0EFD3", "#E0BCBC"], // Red, Slate Blue, Gold
      ["#00FF00", "#0000FF", "#FF69B4"], // Green, Blue, Hot Pink
      ["#FF9900", "#800080", "#008080"], // Orange, Purple, Teal
      ["#1E90FF", "#FF4500", "#32CD32"], // Dodger Blue, Orange Red, Lime Green
    ],
  },
  {
    id: "shape8",
    selectedpalate: 0,
    data: [
      {
        fill: "#07425F",
        id: "shape8-1",
        d: `M327.9,0C304.5,18.3,275,29.2,243,29.2c-15,0-29.4-2.4-43-6.8c-13.5,4.4-28,6.8-43,6.8
            c-32,0-61.5-10.9-84.9-29.3C41,57.2,23.2,121.3,23.2,192.5v0.5C23.2,342.7,200,400,200,400s176.8-57.3,176.8-207.1v-0.5
            C376.8,121.3,359,57.2,327.9,0z`,
      },
      {
        fill: "#78A2BC",
        id: "shape8-2",
        d: `M319.4,23c-21.3,16.7-51,21.2-80.2,21.2c-13.7,0-26.9-2.2-39.2-6.2c-12.3,4-25.5,6.2-39.2,6.2
            c-29.2,0-62.5-7.3-83.9-24c-28.4,52.2-38.2,108.1-38.2,173v0.4C38.7,330.2,200,386.2,200,386.2s161.3-56,161.3-192.6v-0.4
            C361.3,128.2,347.8,75.2,319.4,23z M171.1,351.1l-2.1,4.4l-2.2-4.4l-4.8-0.7l3.5-3.4l-0.8-4.8l4.3,2.3l4.3-2.3l-0.8,4.8l3.5,3.4
            L171.1,351.1z M202.9,363.6l-3.3,6.8l-3.4-6.8l-7.5-1.1l5.4-5.3l-1.3-7.5l6.7,3.5l6.7-3.5l-1.3,7.5l5.4,5.3L202.9,363.6z
             M233.2,351.1l-2.2,4.4l-2.1-4.4l-4.8-0.7l3.5-3.4l-0.8-4.8l4.3,2.3l4.3-2.3l-0.8,4.8l3.5,3.4L233.2,351.1z`,
      },
    ],
    palette: [
      ["#07425F", "#78A2BC"], // Red, Slate Blue
      ["#00FF00", "#0000FF"], // Green, Blue
      ["#FF9900", "#800080"], // Orange, Purple
      ["#1E90FF", "#FF4500"], // Dodger Blue, Orange Red
    ],
  },
  {
    id: "shape9",
    selectedpalate: 0,
    data: [
      {
        fill: "#E5AA7C",
        id: "shape9-1",
        d: `M400,199.5c0,2.9,0,5.8-0.2,8.7c-0.4,10.9-9.5,19.4-20.4,19.3c-0.1,0-0.1,0-0.2,0c-33.9,0-61.3,27.5-61.3,61.3
            c0,20.7,8.5,57-4,75.6C281.6,386.9,242.3,400,200,400s-81.6-13.1-113.9-35.6c-12.5-18.6-4-54.9-4-75.6c0-33.9-27.5-61.3-61.3-61.3
            c-0.1,0-0.1,0-0.2,0c-10.9,0-20-8.4-20.4-19.3C0.1,205.5,0,202.8,0,200C0,89.5,89.5,0,200,0C310.5,0,399.7,89,400,199.5z`,
      },
      {
        fill: "#CC874A",
        id: "shape9-2",
        d: `M322.5,199.7c0,1.8,0,3.5-0.1,5.3c-0.3,6.7-5.8,11.9-12.5,11.9c0,0-0.1,0-0.1,0c-20.8,0-37.6,16.8-37.6,37.6
            c0,12.7,5.2,34.9-2.4,46.3c-19.8,13.7-43.8,21.8-69.8,21.8s-50-8-69.8-21.8c-7.6-11.4-2.4-33.6-2.4-46.3c0-20.8-16.8-37.6-37.6-37.6
            c0,0-0.1,0-0.1,0c-6.7,0-12.2-5.1-12.5-11.8c-0.1-1.7-0.1-3.4-0.1-5.1c0-67.6,54.8-122.5,122.5-122.5
            C267.7,77.5,322.3,132,322.5,199.7z`,
      },
      {
        fill: "#CC874A",
        id: "shape9-3",
        d: `M358.3,194.1h11.5c-3.1-91.3-77.7-164-169.8-164c-91.8,0-166.6,72.9-169.8,164h11.5
            C44.8,109.4,114.5,41.6,200,41.6C285.7,41.6,355.2,109.2,358.3,194.1L358.3,194.1z`,
      },
    ],
    palette: [
      ["#E5AA7C", "#CC874A", "#CC874A"], // Red, Slate Blue, Dark Turquoise
      ["#00FF00", "#0000FF", "#FFA500"], // Green, Blue, Orange
      ["#FF9900", "#800080", "#4682B4"], // Orange, Purple, Steel Blue
      ["#1E90FF", "#FF4500", "#DAA520"],
    ],
  },
  {
    id: "shape10",
    selectedpalate: 0,
    data: [
      {
        fill: "#E6CFCB",
        id: "shape10-1",
        d: `M200,393.5 L323.7,334 L375.1,78 L200,6.5 L24.9,78 L76.3,334 Z`,
      },
      {
        fill: "#CC3928",
        id: "shape10-2",
        d: `M200,400c-1,0-1.9-0.2-2.8-0.6L73.4,339.8c-1.8-0.9-3.2-2.6-3.6-4.6L18.5,79.3c-0.6-3.1,1-6.2,3.9-7.3
            L197.5,0.5c1.6-0.6,3.4-0.6,4.9,0L377.6,72c2.9,1.2,4.5,4.3,3.9,7.3l-51.4,255.9c-0.4,2-1.7,3.7-3.6,4.6l-123.7,59.5
            C201.9,399.8,201,400,200,400z M82,329.5l118,56.8l118-56.8L367.6,82L200,13.6L32.4,82L82,329.5z`,
      },
      {
        fill: "#CC874A",
        id: "shape10-3",
        d: `M200,364.9c-0.1,0-0.3,0-0.4-0.1l-99.8-50.1c-0.2-0.1-0.4-0.3-0.4-0.6L57.9,98.8c-0.1-0.4,0.1-0.8,0.5-0.9
            l141.3-60.1c0.2-0.1,0.4-0.1,0.6,0l141.3,60.1c0.4,0.2,0.6,0.5,0.5,0.9l-41.4,215.4c0,0.3-0.2,0.5-0.4,0.6l-99.8,50.1
            C200.3,364.9,200.1,364.9,200,364.9z M100.9,313.4l99.1,49.7l99.1-49.7l41.2-214.3L200,39.3L59.7,99.1L100.9,313.4z`,
      },
      {
        fill: "#CB3827",
        id: "shape10-4",
        d: `M200.5,372.5c-0.1,0-0.3,0-0.4-0.1L94.2,320c-0.2-0.1-0.4-0.3-0.4-0.6L49.8,94c-0.1-0.4,0.1-0.8,0.5-0.9
                l149.9-63c0.2-0.1,0.4-0.1,0.6,0l149.9,63c0.4,0.2,0.6,0.5,0.5,0.9l-44,225.5c0,0.3-0.2,0.5-0.4,0.6l-105.9,52.4
                C200.7,372.5,200.6,372.5,200.5,372.5z M95.3,318.7l105.2,52.1l105.2-52.1l43.8-224.4l-149-62.6L51.5,94.3L95.3,318.7z`,
      },
    ],
    palette: [
      ["#E6CFCB", "#CC3928", "#CC874A", "#CB3827"], // Red, Slate Blue, Dark Turquoise, Gold
      ["#00FF00", "#0000FF", "#FFA500", "#DC143C"], // Green, Blue, Orange, Crimson
      ["#FF9900", "#800080", "#4682B4", "#32CD32"], // Orange, Purple, Steel Blue, Lime Green
      ["#1E90FF", "#FF4500", "#DAA520", "#8A2BE2"], // Dodger
    ],
  },
  {
    id: "shape11",
    selectedpalate: 0,
    data: [
      {
        fill: "#D25F5B",
        id: "shape11-1",
        d: `M200,400c-5.7,0-11.3-0.8-16.8-2.5L68.5,363.1c-22.7-6.8-38.9-26.4-41.4-49.9L4.2,95.8
            c-1.7-16.5,3.6-33,14.7-45.3s26.9-19.4,43.5-19.4c3.9,0,7.8-0.5,11.6-1.4l111.8-28c9.3-2.3,19.1-2.3,28.4,0L326,29.7
            c3.8,0.9,7.7,1.4,11.6,1.4c16.6,0,32.4,7.1,43.5,19.4s16.5,28.8,14.7,45.3l-22.9,217.4c-2.5,23.5-18.7,43.1-41.4,49.9l-114.7,34.4
            C211.3,399.2,205.7,400,200,400z`,
      },
      {
        fill: "#CC3928",
        id: "shape11-2",
        d: `M200,394.2c-5.1,0-10.3-0.7-15.3-2.2L70.1,357.5c-20.5-6.1-35.3-24-37.6-45.3L9.6,94.8
            c-0.2-1.9-0.3-3.8-0.3-5.6c0-28.9,23.5-53,53.1-53c2.1,0,4.3-0.1,6.4-0.4L200,394.2z`,
      },
      {
        fill: "#AD3524",
        id: "shape11-3",
        d: `M390.4,94.8l-22.9,217.4c-2.3,21.3-17,39.1-37.6,45.3L215.3,392c-5,1.5-10.1,2.2-15.3,2.2L331.2,35.8
            c2.1,0.3,4.3,0.4,6.4,0.4C369.1,36.2,393.7,63.5,390.4,94.8z`,
      },
    ],
    palette: [
      ["#D25F5B", "#CC3928", "#AD3524"], // Red, Slate Blue, Dark Turquoise
      ["#00FF00", "#0000FF", "#FFA500"], // Green, Blue, Orange
      ["#FF9900", "#800080", "#4682B4"], // Orange, Purple, Steel Blue
      ["#1E90FF", "#FF4500", "#DAA520"], // Dod
    ],
  },
  {
    id: "shape12",
    selectedpalate: 0,
    data: [
      {
        fill: "#923F55",
        id: "shape12-1",
        d: `M329.4,400H22.3c-6.4,0-11.5-5.1-11.5-11.5V59.8C10.8,26.8,37.7,0,70.7,0h307c6.4,0,11.5,5.1,11.5,11.5v328.6
            C389.2,373.1,362.3,400,329.4,400z`,
      },
      {
        fill: "#a600ff",
        id: "shape12-2",
        d: `M70.7,23c-20.3,0-36.9,16.5-36.9,36.9V377h295.6c20.3,0,36.9-16.5,36.9-36.9V23H70.7z M67,64.8
            c-4.6,0-8.3-3.7-8.3-8.3s3.7-8.3,8.3-8.3c4.6,0,8.3,3.7,8.3,8.3S71.6,64.8,67,64.8z M330.8,351.2c-4.6,0-8.3-3.7-8.3-8.3
            c0-4.6,3.7-8.3,8.3-8.3c4.6,0,8.3,3.7,8.3,8.3C339.1,347.5,335.4,351.2,330.8,351.2z`,
      },
    ],
    palette: [
      ["#923F55", "#a600ff"], // Red, Slate Blue
      ["#00FF00", "#0000FF"], // Green, Blue
      ["#FF9900", "#800080"], // Orange, Purple
      ["#1E90FF", "#FF4500"], // Dodger Blue, Orange Red
    ],
  },
  {
    id: "shape13",
    selectedpalate: 0,
    data: [
      {
        fill: "#923F55",
        id: "shape13-1",
        d: `M20 20 H380 V380 H20 Z`,
      },
    ],
    palette: [
      ["#923F55"], // Red
      ["#00FF00"], // Green
      ["#FF9900"], // Orange
      ["#1E90FF"], // Dodger Blue
    ],
  },
  {
    id: "shape14",
    selectedpalate: 0,
    data: [
      {
        fill: "#a600ff",
        id: "shape14-1",
        d: `M200 50 L50 350 L350 350 Z`,
      },
    ],
    palette: [
      ["#a600ff"], // Red
      ["#00FF00"], // Green
      ["#FF9900"], // Orange
      ["#1E90FF"], // Dodger Blue
    ],
  },
  {
    id: "shape15",
    selectedpalate: 0,
    data: [
      {
        fill: "#2B8383",
        id: "shape15-1",
        d: `M400.002,200.005c0,110.461-89.545,200.006-200.003,200.006C89.542,400.011,0,310.466,0,200.005
          C0,89.552,89.542,0,199.999,0C310.457,0,400.002,89.552,400.002,200.005z`,
      },
      {
        fill: "#075B60",
        id: "shape15-2",
        d: `M249.061,383.112C147.929,410.203,44,350.201,16.895,249.072C-10.198,147.937,49.804,44.007,150.935,16.904
          c101.133-27.092,205.079,32.903,232.169,134.04C410.203,252.082,350.193,356.014,249.061,383.112z`,
      },
      {
        fill: "#9BC4C2",
        id: "shape15-3",
        d: `M16.875,249.072c7.329,27.348,20.286,51.682,37.276,72.104h291.631
          c19.988-24.094,33.854-52.927,40.083-83.853H14.135C14.924,241.24,15.827,245.159,16.875,249.072z`,
      },
    ],
    palette: [
      ["#2B8383", "#075B60", "#9BC4C2"], // Red, Slate Blue, Dark Turquoise
      ["#00FF00", "#0000FF", "#FFA500"], // Green, Blue, Orange
      ["#FF9900", "#800080", "#4682B4"], // Orange, Purple, Steel Blue
      ["#1E90FF", "#FF4500", "#DAA520"], // Dodger Blue, Orange Red, Goldenrod
    ],
  },
  {
    id: "shape16",
    selectedpalate: 0,
    data: [
      {
        fill: "#002F46",
        id: "shape16-1",
        d: `M342.65,0 L342.65,308.25 L200,400 L57.35,308.25 L75.85,294.2 L97.67,308.25 L200,374.07 L302.33,308.25 L324.15,294.2 L324.15,19.76 Z`,
      },
      {
        fill: "#627F96",
        id: "shape16-2",
        d: `M342.65,0 L324.15,19.76 L75.85,19.76 L75.85,294.2 L57.35,308.25 L57.35,0 Z`,
      },
      {
        fill: "#E3E7E5",
        id: "shape16-3",
        d: `M324.15,19.76 L324.15,294.2 L302.33,308.25 L200,374.07 L97.67,308.25 L75.85,294.2 L75.85,19.76 Z`,
      },
    ],
    palette: [
      ["#002F46", "#627F96", "#E3E7E5"], // Red, Slate Blue, Dark Turquoise
      ["#00FF00", "#0000FF", "#FFA500"], // Green, Blue, Orange
      ["#FF9900", "#800080", "#4682B4"], // Orange, Purple, Steel Blue
      ["#1E90FF", "#FF4500", "#DAA520"], // Dodger Blue, Orange Red, Goldenrod
    ],
  },
  {
    id: "shape17",
    selectedpalate: 0,
    data: [
      {
        fill: "#ABCED4",
        id: "shape17-1",
        d: `M200,0a200,200 0 1,0 0,400a200,200 0 1,0 0,-400Z`,
      },
      {
        fill: "#5D99AA",
        id: "shape17-2",
        d: `M200,373.2c61.3,0,115.2-32,146-80.2c-125.4-36.4-247.3-11.4-291.8,0.3C85,341.3,138.9,373.2,200,373.2z`,
      },
      {
        fill: "#24798D",
        id: "shape17-3",
        d: `M199.5,346.4l7-3.7l-1.3,7.8l5.6,5.5l-7.8,1.1l-3.5,7.1l-3.5-7.1l-7.8-1.1l5.6-5.5l-1.3-7.8Z`,
      },
      {
        fill: "#E3E7E5",
        id: "shape17-4",
        d: `M167.6,337.2l4.4-2.4l-0.8,5l3.6,3.6l-5,0.7l-2.2,4.5l-2.2-4.5l-5-0.7l3.6-3.6l-0.8-5Z`,
      },
      {
        fill: "#24798D",
        id: "shape17-5",
        d: `M232.4,337.2l4.5-2.4l-0.8,5l3.6,3.6l-5,0.7l-2.2,4.5l-2.2-4.5l-5-0.7l3.6-3.6l-0.8-5Z`,
      },
      {
        fill: "#5D99AA",
        id: "shape17-6",
        d: `M323.3,78.5C291.9,46.6,248.2,26.8,200,26.8c-48.6,0-92.5,20.1-124,52.4C176.3,102.9,271.5,89.8,323.3,78.5z`,
      },
    ],
    palette: [
      ["#ABCED4", "#5D99AA", "#24798D", "#E3E7E5", "#24798D", "#5D99AA"], // Red, Slate Blue, Dark Turquoise, Gold, Crimson, Forest Green
      ["#00FF00", "#0000FF", "#FFA500", "#8A2BE2", "#B22222", "#5F9EA0"], // Green, Blue, Orange, Blue Violet, Firebrick, Cadet Blue
      ["#FF9900", "#800080", "#4682B4", "#32CD32", "#FF1493", "#708090"], // Orange, Purple, Steel Blue, Lime Green, Deep Pink, Slate Gray
      ["#1E90FF", "#FF4500", "#DAA520", "#2E8B57", "#9932CC", "#A52A2A"], // Dodger Blue, Orange Red, Goldenrod, Sea Green, Dark Orchid, Brown
    ],
  },
  {
    id: "shape18",
    selectedpalate: 0,
    data: [
      {
        fill: "#1A2655",
        id: "shape18-1",
        d: `M200,7.4L200,392.6L39.5,344.4L7.4,39.5L71.6,39.5Z`,
      },
      {
        fill: "#394784",
        id: "shape18-2",
        d: `M392.6,39.5L360.5,344.4L200,392.6L200,7.4L328.4,39.5Z`,
      },
      {
        fill: "#24798D",
        id: "shape18-3",
        d: `M200,216.9L30.5,250L16,112.3L200,72.1Z`,
      },
      {
        fill: "#E3E7E5",
        id: "shape18-4",
        d: `M200,216.9L369.5,250L384,112.3L200,72.1Z`,
      },
      {
        fill: "#24798D",
        id: "shape18-5",
        d: `M375.4,53.8c-0.2-0.2-0.5-0.3-0.7-0.3h-58.1L200.2,24.4c0,0,0,0-0.1,0c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.3,0
              c0,0,0,0,0,0L83.4,53.5H25.3c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.5-0.3,0.8l29.1,276.6c0,0.4,0.3,0.7,0.7,0.8l145.6,43.7
              c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3-0.1l145.5-43.7c0.4-0.1,0.7-0.4,0.7-0.8l29.1-276.6C375.7,54.3,375.6,54,375.4,53.8z
              M344.7,330.3L200,373.6L55.3,330.2L26.4,55.4h57.1c0.1,0,0.2,0,0.2,0l116.2-29l116.2,29.1c0.1,0,0.2,0,0.2,0h57.1L344.7,330.3z`,
      },
      {
        fill: "#5D99AA",
        id: "shape18-6",
        d: `M398.1,34.5c-1.4-1.6-3.4-2.5-5.5-2.5h-63.3L201.9,0.3c-0.3-0.1-0.6-0.1-0.9-0.2c0,0,0,0,0,0
              c-0.2,0-0.5-0.1-0.7-0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.5,0-0.7,0.1c0,0,0,0,0,0c-0.3,0-0.6,0.1-0.9,0.2L70.7,32.1
              H7.4c-2.1,0-4.1,0.9-5.5,2.5c-1.4,1.6-2.1,3.6-1.9,5.7l32.1,304.9c0.3,3,2.4,5.5,5.2,6.3l160.5,48.2c0.2,0.1,0.5,0.1,0.7,0.2
              c0.1,0,0.2,0.1,0.3,0.1c0.4,0.1,0.8,0.1,1.1,0.1c0.4,0,0.7,0,1.1-0.1c0.1,0,0.2-0.1,0.4-0.1c0.2,0,0.4-0.1,0.6-0.1l160.5-48.2
              c2.9-0.9,4.9-3.3,5.2-6.3L400,40.3C400.2,38.2,399.5,36.1,398.1,34.5z M353.7,338.8L200,384.9L46.4,338.8L15.6,46.9h56
              c0.6,0,1.2-0.1,1.8-0.2L200,15l126.6,31.7c0.6,0.2,1.2,0.2,1.8,0.2h56L353.7,338.8z`,
      },
    ],
    palette: [
      ["#1A2655", "#394784", "#24798D", "#E3E7E5", "#24798D", "#5D99AA"], // Vibrant mix
      ["#2ECC71", "#E67E22", "#8E44AD", "#16A085", "#D35400", "#27AE60"], // Earthy tones
      ["#2980B9", "#C0392B", "#F39C12", "#7D3C98", "#17A589", "#A569BD"], // Cool & warm blend
      ["#5DADE2", "#F4D03F", "#58D68D", "#E74C3C", "#AF7AC5", "#34495E"], // Soft & bold mix
    ],
  },
  {
    id: "shape19",
    selectedpalate: 0,
    data: [
      {
        fill: "#E6D84E",
        id: "shape19-1",
        d: `M378.5,223.5 L400,200 L378.5,176.5 L393.2,148.2 L366.3,131.1 L373.2,100 L342.8,90.4 L341.4,58.6 L309.6,57.2 L300,26.8 L268.9,33.7 L251.8,6.8 L223.5,21.5 L200,0 L176.5,21.5 L148.2,6.8 L131.1,33.7 L100,26.8 L90.4,57.2 L58.6,58.6 L57.2,90.4 L26.8,100 L33.7,131.1 L6.8,148.2 L21.5,176.5 L0,200 L21.5,223.5 L6.8,251.8 L33.7,268.9 L26.8,300 L57.2,309.6 L58.6,341.4 L90.4,342.8 L100,373.2 L131.1,366.3 L148.2,393.2 L176.5,378.5 L200,400 L223.5,378.5 L251.8,393.2 L268.9,366.3 L300,373.2 L309.6,342.8 L341.4,341.4 L342.8,309.6 L373.2,300 L366.3,268.9 L393.2,251.8 Z`,
      },
      {
        fill: "#ECEFC0",
        id: "shape19-2",
        d: `M200,22.3 C101.8,22.3 22.3,101.8 22.3,200 C22.3,298.2 101.8,377.8 200,377.8 C298.2,377.8 377.8,298.2 377.8,200 C377.8,101.8 298.2,22.3 200,22.3 Z M200,365.8 C108.4,365.8 34.2,291.6 34.2,200 C34.2,108.4 108.4,34.2 200,34.2 C291.6,34.2 365.8,108.4 365.8,200 C365.8,291.6 291.6,365.8 200,365.8 Z`,
      },
      {
        fill: "#D6C441",
        id: "shape19-3",
        d: `M200,34.2 C108.4,34.2 34.2,108.4 34.2,200 C34.2,291.6 108.4,365.8 200,365.8 C291.6,365.8 365.8,291.6 365.8,200 C365.8,108.4 291.6,34.2 200,34.2 Z`,
      },
      {
        fill: "#F8EB57",
        id: "shape19-4",
        d: `M200,40.1 C111.7,40.1 40.1,111.7 40.1,200 C40.1,288.3 111.7,359.9 200,359.9 C288.3,359.9 359.9,288.3 359.9,200 C359.9,111.7 288.3,40.1 200,40.1 Z M49.6,198.7 C48.9,200.4 49.7,202.5 51.1,201.7 C52.8,200.9 53.6,199.8 53.6,198 C53.6,196.2 52.8,195.1 51.1,194.3 C49.7,193.5 48.9,194.5 49.6,198.7 Z M58.3,228.1 C59,226.4 58.2,224.3 58.3,228.1 C59,229.3 60.1,230.1 61.9,229.3 C63.7,228.5 64.5,227.4 63.8,226.1 C62.9,224.4 61.3,224.7 58.3,228.1 Z M66.8,257.8 C67.6,256 66.7,254 66.8,257.8 C67.6,259.4 69.5,258.7 70.3,257 C71.1,255.3 70.3,253.5 68.5,252.9 C66.7,252.4 67.6,254 66.8,257.8 Z M81.3,284.1 C82.1,282.3 81.2,280.3 81.3,284.1 C82.1,285.9 83.2,286.7 84.9,285.9 C86.7,285.1 87.5,284 86.8,282.7 C85.9,280.9 84.3,281.2 81.3,284.1 Z M98.8,305.7 C99.5,303.9 98.7,301.9 98.8,305.7 C99.5,307.3 101.4,306.6 102.2,305 C103,303.2 102.2,301.4 100.4,300.9 C98.7,300.3 99.5,301.9 98.8,305.7 Z M119.6,322.8 C120.4,321 119.5,319 119.6,322.8 C120.4,324.4 121.4,323.7 122.2,322 C123,320.2 122.2,318.4 120.4,317.8 C118.6,317.2 119.5,319 119.6,322.8 Z M147.3,337.3 C148,335.5 147.2,333.5 147.3,337.3 C148,338.9 149.9,338.2 150.7,336.5 C151.5,334.7 150.7,332.9 148.9,332.3 C147.2,331.7 148,333.5 147.3,337.3 Z M174,345.9 C174.7,344.2 173.8,342.1 174,345.9 C174.7,347.3 176.6,346.6 177.4,344.9 C178.2,343.2 177.4,341.4 175.6,340.8 C173.8,340.2 174.7,342.1 174,345.9 Z M200,350.8 C201.9,350.8 203.4,349.3 203.4,347.4 C203.4,345.5 201.9,344 200,344 C198.1,344 196.6,345.5 196.6,347.4 C196.6,349.3 198.1,350.8 200,350.8 Z M231,347.3 C232.9,347.3 234.5,345.8 234.5,344 C234.5,342.1 232.9,341.4 231,341.4 C229.1,341.4 227.5,342.1 227.5,344 C227.5,345.8 229.1,347.3 231,347.3 Z M257.2,339.2 C259.2,339.2 260.7,337.6 260.7,335.7 C260.7,333.8 259.2,332.2 257.2,332.2 C255.3,332.2 253.7,333.8 253.7,335.7 C253.7,337.6 255.3,339.2 257.2,339.2 Z M283.5,324.9 C285.4,324.9 287,323.4 287,321.5 C287,319.6 285.4,318.1 283.5,318.1 C281.6,318.1 280,319.6 280,321.5 C280,323.4 281.6,324.9 283.5,324.9 Z M304,307.5 C305.9,307.5 307.5,305.9 307.5,304 C307.5,302.1 305.9,300.6 304,300.6 C302.1,300.6 300.5,302.1 300.5,304 C300.5,305.9 302.1,307.5 304,307.5 Z M322.6,285.7 C324.5,285.7 326,284.1 326,282.2 C326,280.3 324.5,278.8 322.6,278.8 C320.7,278.8 319.1,280.3 319.1,282.2 C319.1,284.1 320.7,285.7 322.6,285.7 Z M336,259.8 C338,259.8 339.5,258.3 339.5,256.4 C339.5,254.5 338,253 336,253 C334.1,253 332.5,254.5 332.5,256.4 C332.5,258.3 334.1,259.8 336,259.8 Z M344.7,230.4 C346.6,230.4 348.2,228.8 348.2,226.9 C348.2,225 346.6,223.4 344.7,223.4 C342.8,223.4 341.2,225 341.2,226.9 C341.2,228.8 342.8,230.4 344.7,230.4 Z M347.2,203.4 C349.1,203.4 350.6,201.9 350.6,200 C350.6,198.1 349.1,196.6 347.2,196.6 C345.3,196.6 343.7,198.1 343.7,200 C343.7,201.9 345.3,203.4 347.2,203.4 Z`,
      },
    ],
    palette: [
      ["#E6D84E", "#ECEFC0", "#D6C441", "#F8EB57"], // Vibrant mix
      ["#2ECC71", "#E67E22", "#8E44AD", "#F1C40F"], // Earthy tones
      ["#2980B9", "#C0392B", "#F39C12", "#7D3C98"], // Cool & warm blend
      ["#5DADE2", "#E74C3C", "#AF7AC5", "#34495E"],
    ],
  },
  {
    id: "shape20",
    selectedpalate: 0,
    data: [
      {
        fill: "#F0EFD3",
        id: "shape20-1",
        d: `M396,200c0,108-87.8,195.5-196.1,195.5c-57.5,0-109.2-24.6-145.1-63.9L396,200z`,
      },
      {
        fill: "#F9E8B8",
        id: "shape20-2",
        d: `M396,67.1v120.5L46.9,322.2C21.6,290.9,5.9,251.6,4,208.7L396,67.1z`,
      },
      {
        fill: "#F4D678",
        id: "shape20-3",
        d: `M400,4c0-0.3,0-0.7-0.1-1c-0.4-1.8-2-2.9-3.8-3c0,0,0,0,0,0c0,0,0,0,0,0c-0.2,0-0.4,0-0.6,0.1 c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0l-97.6,24.4c0,0-0.1,0-0.1,0c-0.2,0.1-0.4,0.1-0.6,0.2c0,0-0.1,0-0.1,0.1 c-0.2,0.1-0.4,0.2-0.5,0.3c0,0-0.1,0.1-0.1,0.1c-0.2,0.1-0.3,0.3-0.5,0.4c0,0-0.1,0.1-0.1,0.1c-0.1,0.2-0.3,0.3-0.4,0.5 c0,0-0.1,0.1-0.1,0.1c-0.1,0.2-0.2,0.3-0.2,0.5c0,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2L288.9,49H200h-88.9l-5.8-21.7 c0,0,0,0,0,0c-0.1-0.3-0.2-0.5-0.3-0.7c0,0,0,0,0,0c-0.4-0.9-1.2-1.6-2.2-1.9c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.3-0.1L4.9,0.1 c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0C4.4,0,4.1,0,3.9,0c0,0,0,0,0,0c0,0,0,0-0.1,0C3.6,0,3.4,0,3.2,0.1c0,0-0.1,0-0.1,0 c-0.2,0-0.4,0.1-0.6,0.2c0,0-0.1,0-0.1,0.1C2.1,0.4,1.9,0.5,1.8,0.6c0,0-0.1,0.1-0.1,0.1C1.5,0.9,1.3,1,1.2,1.1c0,0-0.1,0.1-0.1,0.1 C0.9,1.4,0.8,1.5,0.7,1.7c0,0.1-0.1,0.1-0.1,0.2C0.5,2,0.4,2.2,0.3,2.3c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.4 c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.3C0,3.5,0,3.7,0,3.9c0,0,0,0,0,0v196.6c0,0,0,0.1,0,0.1C0,310.6,89.7,400,200,400 c110.2,0,199.9-89.4,200-199.3c0,0,0-0.1,0-0.1V4z M7.9,207.3L392.2,68.5v120.6L50.5,320.8C25.1,289.5,9.4,250.2,7.9,207.3z M98.4,31.6 l6,22.4c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0,0.1,0.1,0.2c0.2,0.4,0.5,0.8,0.8,1.2c0,0,0.1,0.1,0.1,0.1 c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.1,0.4,0.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0.1,0.3,0.1,0.4,0.1 c0.1,0,0.2,0,0.3,0.1c0.2,0,0.5,0.1,0.7,0.1H200h91.9c0.2,0,0.5,0,0.7-0.1c0.1,0,0.2,0,0.3-0.1c0.1,0,0.3-0.1,0.4-0.1 c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.2-0.1,0.4-0.2c0.1,0,0.2-0.1,0.2-0.2c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.1-0.1,0.2-0.2 c0.2-0.2,0.3-0.3,0.4-0.5c0,0,0-0.1,0.1-0.1c0.1-0.2,0.2-0.3,0.3-0.5c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3l6-22.4 l90.5-22.6 v44.9L7.8,193V8.9L98.4,31.6z M200,392.2C200,392.2,200,392.2,200,392.2C200,392.2,200,392.2,200,392.2 c-55.9,0-106.3-23.9-141.5-62.1l333.6-128.6C391.7,306.7,305.7,392.2,200,392.2z`,
      },
    ],
    palette: [
      ["#F0EFD3", "#F9E8B8", "#F4D678"], // Vibrant mix
      ["#2ECC71", "#E67E22", "#F1C40F"], // Earthy tones
      ["#2980B9", "#C0392B", "#7D3C98"], // Cool & warm blend
      ["#5DADE2", "#E74C3C", "#34495E"], // Soft & bold mix
    ],
  },
  {
    id: "shape21",
    selectedpalate: 0,
    data: [
      {
        fill: "#009995",
        id: "shape21-1",
        d: `M219.2,6.5L245,20.3c5,2.7,10.5,4.3,16.1,4.7l29.1,2.3c13.6,1.1,25.8,8.9,32.4,20.8l14.2,25.6
            c2.7,4.9,6.5,9.3,11,12.7L371,104c10.9,8.2,16.9,21.4,16,35l-1.9,29.2c-0.4,5.6,0.4,11.3,2.4,16.6l10,27.4
            c4.7,12.8,2.6,27.1-5.5,38.1l-17.4,23.5c-3.4,4.5-5.7,9.7-7,15.3l-6.4,28.5c-3,13.3-12.5,24.2-25.2,29.1L308.8,357
            c-5.3,2-10.1,5.1-14.1,9.1l-20.8,20.5c-9.7,9.6-23.6,13.7-36.9,10.8l-28.6-6c-5.5-1.2-11.2-1.2-16.8,0l-28.6,6
            c-13.4,2.8-27.2-1.3-36.9-10.8l-20.8-20.5c-4-4-8.8-7.1-14.1-9.1l-27.3-10.4c-12.8-4.8-22.2-15.8-25.2-29.1l-6.4-28.5
            c-1.2-5.5-3.6-10.7-7-15.3L8,250.3c-8.1-11-10.2-25.3-5.5-38.1l10-27.4c1.9-5.3,2.8-11,2.4-16.6L13,139c-0.9-13.6,5.1-26.8,16-35
            l23.3-17.7c4.5-3.4,8.3-7.7,11-12.7l14.2-25.6c6.6-11.9,18.8-19.8,32.4-20.8l29.1-2.3c5.6-0.4,11.1-2,16.1-4.7l25.7-13.8
            C192.8,0,207.2,0,219.2,6.5z`,
      },
      {
        fill: "#9EC4C0",
        id: "shape21-2",
        d: `M160,380.6c-10.8,0-21.3-4.2-29.1-12l-16.9-16.7c-3.9-3.9-8.6-6.9-13.8-8.9L78,334.7
          c-13.1-5-22.7-16.1-25.8-29.8L47,281.8c-1.2-5.4-3.5-10.4-6.8-14.9l-14.1-19.1c-8.3-11.3-10.4-25.8-5.6-39l8.1-22.3
          c1.9-5.2,2.7-10.7,2.3-16.2l-1.5-23.7c-0.9-14,5.2-27.4,16.4-35.8l18.9-14.3c4.4-3.3,8-7.5,10.7-12.4l11.5-20.8
          c6.8-12.3,19.2-20.2,33.1-21.3l23.6-1.8c5.5-0.4,10.8-2,15.7-4.6l20.9-11.2c12.3-6.6,27.1-6.6,39.4,0l0,0l20.9,11.2
          c4.9,2.6,10.2,4.2,15.7,4.6l23.6,1.8c14,1.1,26.3,9,33.1,21.3l11.5,20.8c2.7,4.9,6.3,9,10.7,12.4l18.9,14.3
          c11.1,8.5,17.3,21.8,16.4,35.8l-1.5,23.7c-0.4,5.5,0.4,11,2.3,16.2l8.2,22.3c4.8,13.1,2.7,27.7-5.6,39l-14.1,19.1
          c-3.3,4.5-5.6,9.5-6.8,14.9l-5.2,23.1c-3.1,13.7-12.7,24.8-25.8,29.8l-22.2,8.4c-5.2,2-9.8,5-13.8,8.9l-16.9,16.7
          c-10,9.8-24.1,14-37.8,11.1l-23.2-4.9c-5.4-1.1-10.9-1.1-16.4,0l-23.2,4.9C165.7,380.3,162.8,380.6,160,380.6z M200,21.3
          c-6.4,0-12.9,1.6-18.8,4.8l-20.9,11.2c-5.1,2.8-10.7,4.4-16.5,4.8l-23.7,1.8c-13.3,1-25.1,8.6-31.6,20.3L77.1,85
          c-2.8,5.1-6.6,9.5-11.2,13l-18.9,14.3c-10.6,8.1-16.5,20.9-15.6,34.2l1.5,23.7c0.4,5.8-0.4,11.5-2.4,17l-8.1,22.3
          c-4.6,12.6-2.6,26.5,5.4,37.2l14.1,19.1c3.5,4.7,5.9,9.9,7.1,15.6l5.2,23.1c2.9,13,12.1,23.7,24.6,28.4l22.2,8.4
          c5.4,2.1,10.3,5.2,14.4,9.3l16.9,16.7c9.5,9.4,23,13.4,36.1,10.6l23.2-4.9c5.7-1.2,11.5-1.2,17.2,0l23.2,4.9
          c13.1,2.8,26.6-1.2,36.1-10.6l16.9-16.7c4.1-4.1,9-7.2,14.4-9.3l22.2-8.4c12.5-4.8,21.7-15.4,24.6-28.4l5.2-23.1
          c1.3-5.7,3.7-10.9,7.1-15.6l14.1-19.1c7.9-10.8,9.9-24.6,5.4-37.2l-8.2-22.3c-2-5.5-2.8-11.2-2.4-17l1.5-23.7
          c0.9-13.3-5-26.1-15.6-34.2L334.2,98c-4.6-3.5-8.4-7.9-11.2-13l-11.5-20.8c-6.5-11.7-18.3-19.3-31.6-20.3l-23.6-1.8
          c-5.8-0.5-11.4-2.1-16.5-4.8L218.8,26C212.9,22.8,206.4,21.3,200,21.3z`,
      },
      {
        fill: "#9EC4C0",
        id: "shape21-3",
        d: `M161.8,374.4c-10.8,0-21.3-4.2-29.1-12L117,347c-3.9-3.9-8.6-6.9-13.8-8.9l-20.5-7.8
          c-13.1-5-22.7-16.1-25.8-29.8l-4.8-21.4c-1.2-5.4-3.5-10.4-6.8-14.9l-13-17.6c-8.3-11.3-10.4-25.8-5.6-39l7.5-20.6
          c1.9-5.2,2.7-10.7,2.3-16.2l-1.4-21.9c-0.9-14,5.2-27.4,16.4-35.8L69,100.1c4.4-3.3,8-7.5,10.7-12.4l10.6-19.2
          c6.8-12.3,19.2-20.2,33.1-21.3l21.8-1.7c5.5-0.4,10.8-2,15.7-4.6l19.3-10.4c12.3-6.6,27.1-6.6,39.4,0L239,40.9
          c4.9,2.6,10.2,4.2,15.7,4.6l21.8,1.7c14,1.1,26.3,9,33.1,21.3l10.6,19.2c2.7,4.9,6.3,9,10.7,12.4l17.5,13.2
          c11.2,8.5,17.3,21.9,16.4,35.8l-1.4,21.9c-0.4,5.5,0.4,11,2.3,16.2l7.5,20.6c4.8,13.1,2.7,27.7-5.6,39l-13,17.6
          c-3.3,4.5-5.6,9.5-6.8,14.9l-4.8,21.4c-3.1,13.7-12.7,24.8-25.8,29.8l-20.5,7.8c-5.2,2-9.8,5-13.8,8.9l-15.6,15.4
          c-10,9.8-24.1,14-37.8,11.1l-21.4-4.5c-5.4-1.1-10.9-1.1-16.4,0l-21.4,4.5C167.5,374.1,164.6,374.4,161.8,374.4z M200,27.5
          c-6.4,0-12.9,1.6-18.8,4.8l-19.3,10.4c-5.1,2.8-10.7,4.4-16.5,4.8l-21.8,1.7c-13.3,1-25.1,8.6-31.6,20.3L81.4,88.6
          c-2.8,5.1-6.6,9.5-11.2,13l-17.5,13.2c-10.6,8.1-16.5,20.9-15.6,34.2l1.4,21.9c0.4,5.8-0.4,11.5-2.4,17l-7.5,20.6
          C24,221,26,234.9,33.9,245.6l13,17.6c3.5,4.7,5.9,9.9,7.1,15.6l4.8,21.4c2.9,13,12.1,23.7,24.6,28.4l20.5,7.8
          c5.4,2.1,10.3,5.2,14.4,9.3l15.6,15.4c9.5,9.4,23,13.4,36.1,10.6l21.4-4.5c5.7-1.2,11.5-1.2,17.2,0l21.4,4.5
          c13.1,2.8,26.6-1.2,36.1-10.6l15.6-15.4c4.1-4.1,9-7.2,14.4-9.3l20.5-7.8c12.5-4.8,21.7-15.4,24.6-28.4l4.8-21.4
          c1.3-5.7,3.7-10.9,7.1-15.6l13-17.6c7.9-10.8,9.9-24.6,5.4-37.2l-7.5-20.6c-2-5.5-2.8-11.2-2.4-17l1.4-21.9
          c0.9-13.3-5-26.1-15.6-34.2l-17.5-13.2c-4.6-3.5-8.4-7.9-11.2-13L308,69.4c-6.5-11.7-18.3-19.3-31.6-20.3l-21.8-1.7
          c-5.8-0.5-11.3-2.1-16.5-4.8l-19.3-10.4C212.9,29.1,206.4,27.5,200,27.5z`,
      },
    ],
    palette: [
      ["#009995", "#9EC4C0", "#9EC4C0"], // Orange Red, Slate Blue, Light Sea Green
      ["#32CD32", "#8A2BE2", "#FFD700"], // Lime Green, Blue Violet, Gold
      ["#1E90FF", "#FF6347", "#800080"], // Dodger Blue, Tomato, Purple
      ["#DC143C", "#4682B4", "#F4A460"], // Crimson, Steel Blue, Sandy Brown
    ],
  },
  {
    id: "shape22",
    selectedpalate: 0,
    data: [
      {
        fill: "#D5744D",
        id: "shape22-1",
        d: `M370.2,120.7v-16.3c0-9.5-4.8-18.3-12.7-23.5l-96.3-62.7C224-6.1,176-6.1,138.7,18.2L42.5,80.9
            c-7.9,5.2-12.7,14-12.7,23.5v16.3v155.9l0,0v19.1c0,9.5,4.8,18.3,12.7,23.5l96.3,62.7c37.2,24.3,85.3,24.3,122.5,0l96.3-62.7
            c7.9-5.2,12.7-14,12.7-23.5v-19.1l0,0L370.2,120.7L370.2,120.7z`,
      },
      {
        fill: "#E9BBAE",
        id: "shape22-2",
        d: `M29.8 120.7 H370.3 V276.6 H29.8 Z`,
      },
      {
        fill: "#E9BBAE",
        id: "shape22-3",
        d: `M200,387.8c-21.5,0-43-6.1-61.8-18.3L52,313.4c-8.2-5.4-13.1-14.4-13.1-24.2v-12.6h1.9v12.6
            c0,9.2,4.6,17.7,12.3,22.7l86.2,56.1c36.9,24,84.6,24,121.5,0l86.2-56.1c7.7-5,12.3-13.5,12.3-22.7V110.9c0-9.2-4.6-17.7-12.3-22.7
            l-86.2-56.1c-36.9-24-84.6-24-121.5,0L53,88.2c-7.7,5-12.3,13.5-12.3,22.7v9.8h-1.9v-9.8c0-9.8,4.9-18.9,13.1-24.2l86.2-56.1
            c37.5-24.4,86-24.4,123.6,0l86.3,56c8.2,5.4,13.1,14.4,13.1,24.2v178.3c0,9.8-4.9,18.9-13.1,24.2l-86.2,56.1
            C243,381.7,221.5,387.8,200,387.8z`,
      },
      {
        fill: "#E9BBAE",
        id: "shape22-4",
        d: `M200,379.2c-21.5,0-43-6.1-61.8-18.3l-79.6-51.8c-8.2-5.4-13.1-14.4-13.1-24.2V115.2c0-9.8,4.9-18.9,13.1-24.2
            l79.6-51.8c37.5-24.4,86-24.4,123.6,0L341.4,91c8.2,5.4,13.1,14.4,13.1,24.2v169.6c0,9.8-4.9,18.9-13.1,24.2l-79.6,51.8
            C243,373.1,221.5,379.2,200,379.2z M200,22.6c-21.1,0-42.3,6-60.8,18L59.7,92.5c-7.7,5-12.3,13.5-12.3,22.7v169.7
            c0,9.2,4.6,17.7,12.3,22.7l79.6,51.8c36.9,24,84.6,24,121.5,0l79.6-51.8c7.7-5,12.3-13.5,12.3-22.7V115.2c0-9.2-4.6-17.7-12.3-22.7
            l-79.6-51.8C242.3,28.7,221.1,22.6,200,22.6z`,
      },
    ],
    palette: [
      ["#D5744D", "#E9BBAE", "#E9BBAE", "#E9BBAE"], // Orange Red, Slate Blue, Light Sea Green, Gold
      ["#32CD32", "#8A2BE2", "#FFD700", "#FF69B4"], // Lime Green, Blue Violet, Gold, Hot Pink
      ["#1E90FF", "#FF6347", "#800080", "#40E0D0"], // Dodger Blue, Tomato, Purple, Turquoise
      ["#DC143C", "#4682B4", "#F4A460", "#2E8B57"], // Crimson, Steel Blue, Sandy Brown, Sea Green
    ],
  },
  {
    id: "shape23",
    selectedpalate: 0,
    data: [
      {
        fill: "#519670",
        id: "shape23-1",
        d: `M342.9,67.4L220.6,8.5c-13-6.3-28.2-6.3-41.2,0L57.1,67.4c-13,6.3-22.5,18.1-25.7,32.2L1.2,232
                c-3.2,14.1,0.2,28.9,9.2,40.2L95,378.3c9,11.3,22.7,17.9,37.1,17.9h135.8c14.4,0,28.1-6.6,37.1-17.9l84.6-106.1
                c9-11.3,12.4-26.1,9.2-40.1L368.6,99.6C365.4,85.6,355.9,73.7,342.9,67.4z`,
      },
      {
        fill: "#D4E8DA",
        id: "shape23-2",
        d: `M275.1,373H124.9c-2.9,0-5.5-1.3-7.3-3.5L24,252.1c-1.8-2.2-2.5-5.1-1.8-7.9L55.6,97.8c0.6-2.8,2.5-5.1,5.1-6.4
                l135.3-65.1c2.6-1.2,5.6-1.2,8.1,0l135.3,65.1c2.6,1.3,4.4,3.6,5.1,6.4l33.4,146.4c0.6,2.8,0,5.7-1.8,7.9l-93.6,117.4
                C280.6,371.7,277.9,373,275.1,373z`,
      },
      {
        fill: "#E9BBAE",
        id: "shape23-3",
        d: `M373.5,243.8L340.6,99.7c-0.5-2.2-2-4.1-4.1-5.1L203.3,30.4c-2.1-1-4.5-1-6.6,0L63.5,94.6
                c-2.1,1-3.6,2.9-4.1,5.1L26.5,243.8c-0.5,2.2,0,4.6,1.5,6.4l92.2,115.6c1.4,1.8,3.6,2.9,5.9,2.9h147.8c2.3,0,4.5-1.1,5.9-2.9
                L372,250.3C373.4,248.4,374,246.1,373.5,243.8z M139.3,90.1l59.3-28.5c0.9-0.4,2-0.4,2.9,0l59.3,28.5c1.6,0.8,2.3,2.8,1.5,4.4
                c-0.6,1.2-1.8,1.9-3,1.9c-0.5,0-1-0.1-1.4-0.3L200,68.2l-57.8,27.8c-1.6,0.8-3.6,0.1-4.4-1.5C137,92.9,137.7,90.9,139.3,90.1z
                 M293.8,306.3l-28.4,35.6c-0.6,0.8-1.6,1.2-2.6,1.2H137.2c-1,0-2-0.5-2.6-1.2l-28.4-35.6c-1.1-1.4-0.9-3.5,0.5-4.6
                c1.4-1.1,3.5-0.9,4.6,0.5l27.4,34.4h122.5l27.4-34.4c1.1-1.4,3.2-1.7,4.6-0.5C294.7,302.8,295,304.8,293.8,306.3z`,
      },
    ],
    palette: [
      ["#519670", "#D4E8DA", "#E9BBAE"], // Orange Red, Slate Blue, Light Sea Green
      ["#32CD32", "#8A2BE2", "#FFD700"], // Lime Green, Blue Violet, Gold
      ["#1E90FF", "#FF6347", "#800080"], // Dodger Blue, Tomato, Purple
      ["#DC143C", "#4682B4", "#F4A460"], // Crimson, Steel Blue, Sandy Brown
    ],
  },
  {
    id: "shape24",
    selectedpalate: 0,
    data: [
      {
        fill: "#8BA9BC",
        id: "shape24-1",
        d: `M200,400c-39.7,0-79.3-3.7-118.8-11c-5.1-1-8.8-5.4-8.8-10.6c0-28.4-23.1-51.4-51.4-51.4
                c-5.9,0-10.8-4.8-10.8-10.8V82.7c0-5.9,4.8-10.8,10.8-10.8c28.4,0,51.4-23.1,51.4-51.4c0-5.2,3.8-9.7,9-10.6
                c78.7-13.2,158.4-13.2,237.1,0c5.2,0.9,9,5.3,9,10.6c0,28.4,23.1,51.4,51.4,51.4c5.9,0,10.8,4.8,10.8,10.8v233.5
                c0,5.9-4.8,10.8-10.8,10.8c-28.4,0-51.4,23.1-51.4,51.4c0,5.2-3.7,9.6-8.8,10.6C279.4,396.3,239.7,400,200,400z`,
      },
      {
        fill: "#0D435F",
        id: "shape24-2",
        d: `M306.6,29.8c-70.8-11-142.4-11-213.2,0c-4.1,32.3-29.5,58.1-61.6,62.9v213.6c32.2,4.8,57.6,30.6,61.6,63
                c70.8,12.3,142.4,12.3,213.2,0c4-32.4,29.4-58.3,61.6-63V92.6C336.1,87.9,310.7,62.1,306.6,29.8z M121.4,46.4
                c-1.8,0-3.2-1.5-3.2-3.2c0-1.8,1.5-3.2,3.2-3.2s3.2,1.5,3.2,3.2C124.6,45,123.2,46.4,121.4,46.4z M136.9,45.3
                c-1.8,0-3.2-1.5-3.2-3.2c0-1.8,1.5-3.2,3.2-3.2c1.8,0,3.2,1.5,3.2,3.2C140.1,43.9,138.7,45.3,136.9,45.3z M152.6,44.4
                c-1.8,0-3.2-1.5-3.2-3.2s1.5-3.2,3.2-3.2c1.8,0,3.2,1.5,3.2,3.2S154.4,44.4,152.6,44.4z M168.8,43.2c-1.8,0-3.2-1.5-3.2-3.2
                c0-1.8,1.5-3.2,3.2-3.2c1.8,0,3.2,1.5,3.2,3.2C172,41.7,170.5,43.2,168.8,43.2z M184.8,43.2c-1.8,0-3.2-1.5-3.2-3.2
                c0-1.8,1.5-3.2,3.2-3.2c1.8,0,3.2,1.5,3.2,3.2C188,41.7,186.5,43.2,184.8,43.2z M200.1,43.2c-1.8,0-3.2-1.5-3.2-3.2
                c0-1.8,1.5-3.2,3.2-3.2c1.8,0,3.2,1.5,3.2,3.2C203.4,41.7,201.9,43.2,200.1,43.2z M214.9,43.2c-1.8,0-3.2-1.5-3.2-3.2
                c0-1.8,1.5-3.2,3.2-3.2c1.8,0,3.2,1.5,3.2,3.2C218.2,41.7,216.7,43.2,214.9,43.2z M231.2,43.8c-1.8,0-3.2-1.5-3.2-3.2
                c0-1.8,1.5-3.2,3.2-3.2c1.8,0,3.2,1.5,3.2,3.2C234.4,42.3,233,43.8,231.2,43.8z M248.5,44.4c-1.8,0-3.2-1.5-3.2-3.2s1.5-3.2,3.2-3.2
                c1.8,0,3.2,1.5,3.2,3.2S250.3,44.4,248.5,44.4z M263.5,45.3c-1.8,0-3.2-1.5-3.2-3.2c0-1.8,1.5-3.2,3.2-3.2c1.8,0,3.2,1.5,3.2,3.2
                C266.7,43.9,265.3,45.3,263.5,45.3z M279.2,46.4c-1.8,0-3.2-1.5-3.2-3.2c0-1.8,1.5-3.2,3.2-3.2c1.8,0,3.2,1.5,3.2,3.2
                C282.5,45,281,46.4,279.2,46.4z`,
      },
    ],
    palette: [
      ["#8BA9BC", "#0D435F"], // Orange Red, Slate Blue
      ["#32CD32", "#8A2BE2"], // Lime Green, Blue Violet
      ["#1E90FF", "#FF6347"], // Dodger Blue, Tomato
      ["#DC143C", "#4682B4"], // Crimson, Steel Blue
    ],
  },
  {
    id: "shape25",
    selectedpalate: 0,
    data: [
      {
        fill: "#C04322",
        id: "shape25-1",
        d: `M290.4,22.4l-6,22.6H115.7l-6-22.6L20,0c0,30,0.3,58.5,1.4,85.5c0.2,0.1,0.4,0.1,0.6,0.2
                c-0.2-0.1-0.4-0.1-0.6-0.2c0.1,2.5,0.2,5,0.3,7.5c3,68.9,10.9,127.6,30.1,175.5h0c0,0,0,0,0,0c1.2,3.1,2.5,6.1,3.8,9.1
                c25.8,57.8,69.8,99,144.3,122.3c74.5-23.3,118.5-64.5,144.3-122.3c0,0-0.1,0-0.1,0c0,0,0.1,0,0.1,0c1.1-2.4,2.1-4.8,3.1-7.3
                c19.6-47.8,27.7-106.5,30.8-175.3c0,0,0,0,0,0c0.1-2.5,0.2-5,0.3-7.5C379.6,60,380,30.8,380,0L290.4,22.4z`,
      },
      {
        fill: "#D6756D",
        id: "shape25-2",
        d: `M378.5,87.6c-55.8,14.4-114.4,22-174.7,22c-63.1,0-124.3-8.4-182.5-24.1c0.1,2.5,0.2,5,0.3,7.5
                c3,68.9,10.9,127.6,30.1,175.5h0c0,0,0,0,0,0c1.2,3.1,2.5,6.1,3.8,9.1c46.6,9.8,94.8,14.9,144.3,14.9c49.5,0,97.7-5.1,144.3-14.9
                c1.1-2.4,2.1-4.8,3.1-7.3c19.6-47.8,27.7-106.5,30.8-175.3c0,0,0,0,0,0C378.3,92.6,378.5,90.1,378.5,87.6z`,
      },
      {
        fill: "#E6CFCB",
        id: "shape25-3",
        d: `M378.2,95.1c-3.1,68.9-11.2,127.5-30.8,175.3c-46.3,9.7-94.3,14.8-143.5,14.8c-52.2,0-103.1-5.7-152-16.6h0
                C32.6,220.6,24.7,161.9,21.7,93c58.1,15.6,119.1,24,182.2,24C264.1,117,322.5,109.4,378.2,95.1z`,
      },
    ],
    palette: [
      ["#C04322", "#D6756D", "#E6CFCB"], // Coral, Slate Blue, Light Sea Green
      ["#32CD32", "#FF4500", "#FFD700"], // Lime Green, Orange Red, Gold
      ["#1E90FF", "#FF6347", "#8A2BE2"], // Dodger Blue, Tomato, Blue Violet
      ["#DC143C", "#4682B4", "#F4A460"], // Crimson, Steel Blue, Sandy Brown
    ],
  },
  {
    id: "shape26",
    selectedpalate: 0,
    data: [
      {
        fill: "#8DB5C2",
        id: "shape26-1",
        d: `M397.3,47.6c-24.8,0-44.9-20.2-44.9-44.9c0-1.5-1.2-2.7-2.7-2.7H50.3c-1.5,0-2.7,1.2-2.7,2.7
                 c0,24.8-20.2,44.9-44.9,44.9c-1.5,0-2.7,1.2-2.7,2.7V200c0,110.3,89.7,200,200,200s200-89.7,200-200V50.3
                 C400,48.8,398.8,47.6,397.3,47.6z`,
      },
      {
        fill: "#E8F3F5",
        id: "shape26-2",
        d: `M383.6,85.8V61.4c-24.4,0-44.1-19.8-44.1-44.1H62.2c0,24.3-19.7,44.1-44.1,44.1v24.4H383.6z`,
      },
      {
        fill: "#E8F3F5",
        id: "shape26-3",
        d: `M18.2,206.7c3.5,97.8,83.8,176.1,182.6,176.1s179.1-78.3,182.7-176.1H18.2z`,
      },
    ],
    palette: [
      ["#8DB5C2", "#E8F3F5", "#E8F3F5"], // Deep Pink, Steel Blue, Lime Green
      ["#FFA500", "#8A2BE2", "#20B2AA"], // Orange, Blue Violet, Light Sea Green
      ["#1E90FF", "#FF4500", "#FFD700"], // Dodger Blue, Orange Red, Gold
      ["#DC143C", "#6A5ACD", "#40E0D0"], // Crimson, Slate Blue, Turquoise
    ],
  },
  {
    id: "shape27",
    selectedpalate: 0,
    data: [
      {
        fill: "#2C57A4",
        id: "shape27-1",
        d: `M200,1.1 L234.9,24.4 L276.1,16.2 L299.5,51.1 L340.7,59.3 L348.9,100.5 L383.8,123.9 L375.6,165.1 L398.9,200 
               L375.6,234.9 L383.8,276.1 L348.9,299.5 L340.7,340.7 L299.5,348.9 L276.1,383.8 L234.9,375.6 L200,398.9 L165.1,375.6 L123.9,383.8 
               L100.5,348.9 L59.3,340.7 L51.1,299.5 L16.2,276.1 L24.4,234.9 L1.1,200 L24.4,165.1 L16.2,123.9 L51.1,100.5 L59.3,59.3 L100.5,51.1 
               L123.9,16.2 L165.1,24.4 Z`,
      },
      {
        fill: "#AFC4E5",
        id: "shape27-2",
        d: `M200,400l-35.1-23.5l-41.4,8.2L100,349.7l-41.4-8.2L50.3,300l-35.1-23.5l8.2-41.4L0,200l23.5-35.1l-8.2-41.4
                 L50.3,100l8.2-41.4l41.4-8.3l23.5-35.1l41.4,8.2L200,0l35.1,23.5l41.4-8.2L300,50.3l41.4,8.2l8.2,41.4l35.1,23.5l-8.2,41.4L400,200
                 l-23.5,35.1l8.2,41.4L349.7,300l-8.2,41.4l-41.4,8.2l-23.5,35.1l-41.4-8.2L200,400z M165.3,374.7l0.3,0.2l34.4,23l34.7-23.2l41,8.1
                 l23.2-34.7l41-8.1l8.2-41l34.7-23.2l-8.1-41l23.2-34.8l-23.2-34.7l8.1-41l-34.7-23.2l-8.2-41l-41-8.2l-23.2-34.7l-41,8.1l-0.3-0.2
                 L200,2.1l-34.8,23.2l-41-8.1l-23.2,34.7l-41,8.2l-8.2,41l-34.7,23.2l8.1,41L2.1,200l23.2,34.7l-8.1,41l34.7,23.2l8.2,41l41,8.1
                 l0.2,0.3l23,34.4L165.3,374.7z`,
      },
      {
        fill: "#B0C5E6",
        id: "shape27-3",
        d: `M200,384.1c-0.2,0-0.4-0.1-0.6-0.2l-31.8-21.3l-37.5,7.5c-0.4,0.1-0.8-0.1-1-0.4l-21.3-31.8l-37.5-7.5
                 c-0.4-0.1-0.7-0.4-0.8-0.8l-7.5-37.5l-31.8-21.3c-0.3-0.2-0.5-0.6-0.4-1l7.5-37.5l-21.3-31.8c-0.2-0.3-0.2-0.8,0-1.1l21.3-31.8
                 l-7.5-37.5c-0.1-0.4,0.1-0.8,0.4-1l31.8-21.3l7.5-37.5c0.1-0.4,0.4-0.7,0.8-0.8l37.5-7.5l21.3-31.8c0.2-0.3,0.6-0.5,1-0.4l37.5,7.5
                 l31.8-21.3c0.3-0.2,0.8-0.2,1.1,0l31.8,21.3l37.5-7.5c0.4-0.1,0.8,0.1,1,0.4l21.3,31.8l37.5,7.5c0.4,0.1,0.7,0.4,0.8,0.8l7.5,37.5
                 l31.8,21.3c0.3,0.2,0.5,0.6,0.4,1l-7.5,37.5l21.3,31.8c0.2,0.3,0.2,0.8,0,1.1l-21.3,31.8l7.5,37.5c0.1,0.4-0.1,0.8-0.4,1l-31.8,21.3
                 l-7.5,37.5c-0.1,0.4-0.4,0.7-0.8,0.8l-37.5,7.5l-21.3,31.8c-0.2,0.3-0.6,0.5-1,0.4l-37.5-7.5l-31.8,21.3
                 C200.4,384,200.2,384.1,200,384.1z M167.9,360.6c0.2,0,0.4,0.1,0.6,0.2l31.6,21.1l31.6-21.1c0.2-0.1,0.5-0.2,0.8-0.1l37.3,7.4
                 l21.1-31.6c0.1-0.2,0.4-0.4,0.6-0.4l37.3-7.4l7.4-37.3c0-0.3,0.2-0.5,0.4-0.6l31.6-21.1l-7.4-37.3c0-0.3,0-0.5,0.1-0.8l21.1-31.6
                 l-21.1-31.6c-0.1-0.2-0.2-0.5-0.1-0.8l7.4-37.3l-31.6-21.1c-0.2-0.2-0.4-0.4-0.4-0.6l-7.4-37.3l-37.3-7.4c-0.3,0-0.5-0.2-0.6-0.4
                 l-21.1-31.6l-37.3,7.4c-0.3,0-0.5,0-0.8-0.2L200,18.1l-31.6,21.1c-0.2,0.2-0.5,0.2-0.8,0.2l-37.3-7.4l-21.1,31.6
                 c-0.2,0.2-0.4,0.4-0.6,0.4l-37.3,7.4L64,108.6c0,0.3-0.2,0.5-0.4,0.6L32,130.4l7.4,37.3c0,0.3,0,0.5-0.2,0.8L18.1,200l21.1,31.6
                 c0.2,0.2,0.2,0.5,0.2,0.8L32,269.6l31.6,21.1c0.2,0.1,0.4,0.4,0.4,0.6l7.4,37.3l37.3,7.4c0.3,0,0.5,0.2,0.6,0.4l21.1,31.6l37.3-7.4
                 C167.7,360.6,167.8,360.6,167.9,360.6z`,
      },
      {
        fill: "#B0C5E6",
        id: "shape27-4",
        d: `M200,379.1c-0.2,0-0.4-0.1-0.6-0.2l-30.9-20.7l-36.5,7.3c-0.4,0.1-0.8-0.1-1-0.4l-20.7-30.9l-36.5-7.3
                 c-0.4-0.1-0.7-0.4-0.8-0.8l-7.3-36.5L34.9,269c-0.3-0.2-0.5-0.6-0.4-1l7.3-36.5l-20.7-30.9c-0.2-0.3-0.2-0.8,0-1.1l20.7-30.9
                 L34.5,132c-0.1-0.4,0.1-0.8,0.4-1l30.9-20.7l7.3-36.5c0.1-0.4,0.4-0.7,0.8-0.8l36.5-7.3L131,34.9c0.2-0.3,0.6-0.5,1-0.4l36.5,7.3
                 l30.9-20.7c0.3-0.2,0.8-0.2,1.1,0l30.9,20.7l36.5-7.3c0.4-0.1,0.8,0.1,1,0.4l20.7,30.9l36.5,7.3c0.4,0.1,0.7,0.4,0.8,0.8l7.3,36.5
                 l30.9,20.7c0.3,0.2,0.5,0.6,0.4,1l-7.3,36.5l20.7,30.9c0.2,0.3,0.2,0.8,0,1.1l-20.7,30.9l7.3,36.5c0.1,0.4-0.1,0.8-0.4,1l-30.9,20.7
                 l-7.3,36.5c-0.1,0.4-0.4,0.7-0.8,0.8l-36.5,7.3L269,365.1c-0.2,0.3-0.6,0.5-1,0.4l-36.5-7.3L200.6,379
                 C200.4,379.1,200.2,379.1,200,379.1z M168.7,356.2c0.2,0,0.4,0.1,0.6,0.2l30.7,20.5l30.7-20.5c0.2-0.1,0.5-0.2,0.8-0.1l36.2,7.2
                 l20.5-30.7c0.1-0.2,0.4-0.4,0.6-0.4l36.2-7.2l7.2-36.2c0-0.3,0.2-0.5,0.4-0.6l30.7-20.5l-7.2-36.2c0-0.3,0-0.5,0.1-0.8l20.5-30.7
                 l-20.5-30.7c-0.1-0.2-0.2-0.5-0.1-0.8l7.2-36.2l-30.7-20.5c-0.2-0.2-0.4-0.4-0.4-0.6l-7.2-36.2l-36.2-7.2c-0.3-0.1-0.5-0.2-0.6-0.4
                 l-20.5-30.7l-36.2,7.2c-0.3,0-0.5,0-0.8-0.2L200,23.1l-30.7,20.5c-0.2,0.2-0.5,0.2-0.8,0.2l-36.2-7.2l-20.5,30.7
                 c-0.2,0.2-0.4,0.4-0.6,0.4l-36.2,7.2l-7.2,36.2c-0.1,0.3-0.2,0.5-0.4,0.6l-30.7,20.5l7.2,36.2c0,0.3,0,0.5-0.2,0.8L23.1,200
                 l20.5,30.7c0.2,0.2,0.2,0.5,0.2,0.8l-7.2,36.2l30.7,20.5c0.2,0.1,0.4,0.4,0.4,0.6l7.2,36.2l36.2,7.2c0.3,0,0.5,0.2,0.6,0.4
                 l20.5,30.7l36.2-7.2C168.6,356.2,168.7,356.2,168.7,356.2z`,
      },
    ],
    palette: [
      ["#2C57A4", "#AFC4E5", "#B0C5E6", "#B0C5E6"], // Deep Pink, Steel Blue, Lime Green, Gold
      ["#FFA500", "#8A2BE2", "#20B2AA", "#DC143C"], // Orange, Blue Violet, Light Sea Green, Crimson
      ["#1E90FF", "#FF4500", "#FFD700", "#800080"], // Dodger Blue, Orange Red, Gold, Purple
      ["#DC143C", "#6A5ACD", "#40E0D0", "#2E8B57"], // Crimson, Slate Blue, Turquoise, Sea Green
    ],
  },
  {
    id: "shape28",
    selectedpalate: 0,
    data: [
      {
        fill: "#4C5B99",
        id: "shape28-1",
        d: `M396,201.4L350.8,62.2c-10.9-33.6-42.3-56.4-77.6-56.4H126.8c-35.4,0-66.7,22.8-77.6,56.4L4,201.4
                c-10.9,33.6,1,70.5,29.6,91.2l118.4,86c28.6,20.8,67.3,20.8,95.9,0l118.4-86C395,271.8,406.9,235,396,201.4z`,
      },
      {
        fill: "#A9B3C9",
        id: "shape28-2",
        d: `M374,195.1L337.2,81.8c-10.9-33.6-42.3-56.4-77.6-56.4H140.4c-35.4,0-66.7,22.8-77.6,56.4L26,195.1
                c-10.9,33.6,1,70.5,29.7,91.3l96.4,70c28.6,20.8,67.3,20.8,95.9,0l96.4-70C373,265.5,384.9,228.7,374,195.1z M39.2,235.4
                c-0.1,0-0.2,0-0.2,0c-0.5,0-0.9-0.3-1-0.8c-1.1-5-1.7-10.2-1.8-15.3c0-0.6,0.4-1,1-1h0c0.6,0,1,0.5,1,1c0.1,5,0.6,10,1.7,14.9
                C40.1,234.8,39.7,235.3,39.2,235.4z M39.6,204.3c-0.1,0.5-0.5,0.8-1,0.8c-0.1,0-0.1,0-0.2,0c-0.5-0.1-0.9-0.6-0.8-1.2
                c0.6-3,1.4-6,2.3-8.9l1.9-5.9c0.2-0.5,0.8-0.8,1.3-0.7c0.5,0.2,0.8,0.8,0.7,1.3l-1.9,5.9C40.9,198.5,40.2,201.4,39.6,204.3z
                 M51.9,262.9c-0.2,0.1-0.4,0.2-0.6,0.2c-0.3,0-0.6-0.1-0.8-0.4c-3-4.2-5.6-8.7-7.7-13.4c-0.2-0.5,0-1.1,0.5-1.3
                c0.5-0.2,1.1,0,1.3,0.5c2,4.6,4.6,9,7.5,13C52.5,261.9,52.3,262.6,51.9,262.9z M53.2,160.8l-4.7,14.5c-0.1,0.4-0.5,0.7-1,0.7
                c-0.1,0-0.2,0-0.3,0c-0.5-0.2-0.8-0.8-0.7-1.3l4.7-14.5c0.2-0.5,0.8-0.8,1.3-0.7C53.1,159.7,53.4,160.3,53.2,160.8z M65.4,116.7
                l4.7-14.5c0.2-0.5,0.8-0.8,1.3-0.7c0.5,0.2,0.8,0.8,0.6,1.3l-4.7,14.5c-0.1,0.4-0.5,0.7-1,0.7c-0.1,0-0.2,0-0.3,0
                C65.5,117.8,65.2,117.2,65.4,116.7z M56.9,147c-0.1,0-0.2,0-0.3,0c-0.5-0.2-0.8-0.8-0.7-1.3l4.7-14.5c0.2-0.5,0.8-0.8,1.3-0.7
                c0.5,0.2,0.8,0.8,0.7,1.3l-4.7,14.5C57.8,146.8,57.4,147,56.9,147z M74.3,283.4c-0.2,0.3-0.5,0.4-0.8,0.4c-0.2,0-0.4-0.1-0.6-0.2
                l-5.5-4c-2.3-1.7-4.6-3.5-6.7-5.5c-0.4-0.4-0.4-1-0.1-1.4c0.4-0.4,1-0.4,1.4-0.1c2,1.9,4.2,3.7,6.5,5.3l5.5,4
                C74.5,282.3,74.6,282.9,74.3,283.4z M83.6,75c-2.7,4.2-5,8.7-6.8,13.4c-0.2,0.4-0.5,0.7-1,0.7c-0.1,0-0.3,0-0.4-0.1
                c-0.5-0.2-0.8-0.8-0.6-1.3c1.8-4.8,4.2-9.4,7-13.8c0.3-0.5,0.9-0.6,1.4-0.3C83.8,73.9,83.9,74.6,83.6,75z M99,301.3
                c-0.2,0.3-0.5,0.4-0.8,0.4c-0.2,0-0.4-0.1-0.6-0.2l-12.3-9c-0.5-0.3-0.5-1-0.2-1.4c0.3-0.5,1-0.5,1.4-0.2l12.3,9
                C99.2,300.2,99.3,300.9,99,301.3z M104.5,53.7c-4.2,2.8-8.1,6-11.6,9.6c-0.2,0.2-0.5,0.3-0.7,0.3s-0.5-0.1-0.7-0.3
                c-0.4-0.4-0.4-1,0-1.4c3.6-3.7,7.6-7,11.9-9.8c0.5-0.3,1.1-0.2,1.4,0.3C105.1,52.8,105,53.4,104.5,53.7z M123.6,319.2
                c-0.2,0.3-0.5,0.4-0.8,0.4c-0.2,0-0.4-0.1-0.6-0.2l-12.3-9c-0.5-0.3-0.5-1-0.2-1.4c0.3-0.5,1-0.5,1.4-0.2l12.3,9
                C123.8,318.1,124,318.8,123.6,319.2z M132.2,42.5c-4.9,0.9-9.8,2.3-14.4,4.2c-0.1,0-0.3,0.1-0.4,0.1c-0.4,0-0.8-0.2-0.9-0.6
                c-0.2-0.5,0-1.1,0.6-1.3c4.8-1.9,9.7-3.4,14.8-4.3c0.6-0.1,1.1,0.3,1.2,0.8S132.8,42.4,132.2,42.5z M148.3,337.1
                c-0.2,0.3-0.5,0.4-0.8,0.4c-0.2,0-0.4-0.1-0.6-0.2l-12.3-9c-0.4-0.3-0.5-1-0.2-1.4c0.3-0.5,1-0.5,1.4-0.2l12.3,9
                C148.5,336.1,148.6,336.7,148.3,337.1z M147.2,41.2c-0.6,0-1-0.5-1-1s0.5-1,1-1h15.3c0.6,0,1,0.5,1,1s-0.5,1-1,1H147.2z
                 M174.4,352.6c-0.1,0.4-0.5,0.7-0.9,0.7c-0.1,0-0.2,0-0.4-0.1c-4.8-1.8-9.4-4.2-13.8-6.9c-0.5-0.3-0.6-0.9-0.3-1.4
                c0.3-0.5,0.9-0.6,1.4-0.3c4.2,2.7,8.7,5,13.4,6.7C174.4,351.5,174.6,352.1,174.4,352.6z M176.6,40.2c0-0.6,0.5-1,1-1h15.3
                c0.6,0,1,0.5,1,1s-0.5,1-1,1h-15.3C177.1,41.2,176.6,40.8,176.6,40.2z M203.4,358.1c-1.1,0-2.3,0.1-3.4,0.1c-4,0-8-0.3-12-1
                c-0.5-0.1-0.9-0.6-0.8-1.2c0.1-0.5,0.6-0.9,1.2-0.8c4.9,0.8,10,1.1,15,0.8c0.5,0,1,0.4,1.1,1C204.4,357.6,204,358,203.4,358.1z
                 M207.1,40.2c0-0.6,0.5-1,1-1h15.3c0.6,0,1,0.5,1,1s-0.5,1-1,1h-15.3C207.6,41.2,207.1,40.8,207.1,40.2z M233.2,350.5
                c-4.6,2.3-9.5,4-14.5,5.3c-0.1,0-0.2,0-0.3,0c-0.4,0-0.9-0.3-1-0.8c-0.1-0.5,0.2-1.1,0.7-1.2c4.9-1.2,9.6-3,14.1-5.2
                c0.5-0.3,1.1,0,1.4,0.5S233.7,350.2,233.2,350.5z M237.6,40.2c0-0.6,0.5-1,1-1h15.3c0.6,0,1,0.5,1,1s-0.5,1-1,1h-15.3
                C238.1,41.2,237.6,40.8,237.6,40.2z M258.6,333.4l-12.3,9c-0.2,0.1-0.4,0.2-0.6,0.2c-0.3,0-0.6-0.2-0.8-0.4
                c-0.3-0.5-0.2-1.1,0.2-1.4l12.3-9c0.5-0.3,1.1-0.2,1.4,0.2C259.1,332.5,259,333.1,258.6,333.4z M347.8,160.6
                c0.5-0.2,1.1,0.1,1.3,0.6l4.7,14.5c0.2,0.5-0.1,1.1-0.7,1.3c-0.1,0-0.2,0-0.3,0c-0.4,0-0.8-0.3-1-0.7l-4.7-14.5
                C347,161.3,347.3,160.7,347.8,160.6z M328.9,102.6c0.5-0.2,1.1,0.1,1.3,0.7l4.7,14.5c0.2,0.5-0.1,1.1-0.6,1.3c-0.1,0-0.2,0-0.3,0
                c-0.4,0-0.8-0.3-1-0.7l-4.7-14.5C328.1,103.3,328.4,102.7,328.9,102.6z M283.3,315.5l-12.3,9c-0.2,0.1-0.4,0.2-0.6,0.2
                c-0.3,0-0.6-0.1-0.8-0.4c-0.3-0.5-0.2-1.1,0.2-1.4l12.3-9c0.5-0.3,1.1-0.2,1.4,0.2C283.8,314.5,283.7,315.2,283.3,315.5z
                 M284.5,46.5c-0.2,0.4-0.5,0.6-0.9,0.6c-0.1,0-0.3,0-0.4-0.1c-4.6-2-9.4-3.4-14.3-4.4c-0.5-0.1-0.9-0.6-0.8-1.2
                c0.1-0.5,0.6-0.9,1.2-0.8c5,1,10,2.5,14.7,4.5C284.5,45.4,284.7,46,284.5,46.5z M307.9,297.6l-12.3,9c-0.2,0.1-0.4,0.2-0.6,0.2
                c-0.3,0-0.6-0.1-0.8-0.4c-0.3-0.5-0.2-1.1,0.2-1.4l12.3-9c0.5-0.3,1.1-0.2,1.4,0.2C308.5,296.6,308.4,297.3,307.9,297.6z
                 M309.2,64.1c-0.2,0.2-0.5,0.3-0.7,0.3c-0.3,0-0.5-0.1-0.7-0.3c-3.5-3.6-7.3-6.9-11.4-9.8c-0.5-0.3-0.6-1-0.3-1.4
                c0.3-0.5,1-0.6,1.4-0.3c4.2,2.9,8.2,6.3,11.7,10C309.6,63.1,309.6,63.7,309.2,64.1z M317.3,74.5c0.5-0.3,1.1-0.2,1.4,0.3
                c2.7,4.4,5,9,6.8,13.9c0.2,0.5-0.1,1.1-0.6,1.3c-0.1,0-0.3,0.1-0.4,0.1c-0.4,0-0.8-0.3-1-0.7c-1.7-4.7-4-9.2-6.6-13.5
                C316.7,75.4,316.8,74.8,317.3,74.5z M338.5,274.9c-1.9,1.7-3.8,3.3-5.9,4.7l-12.3,9c-0.2,0.1-0.4,0.2-0.6,0.2
                c-0.3,0-0.6-0.2-0.8-0.4c-0.3-0.5-0.2-1.1,0.2-1.4l12.3-9c2-1.4,3.9-3,5.7-4.6c0.4-0.4,1.1-0.3,1.4,0.1
                C338.9,273.9,338.9,274.5,338.5,274.9z M343.7,148c-0.1,0-0.2,0-0.3,0c-0.4,0-0.8-0.3-1-0.7l-4.7-14.5c-0.2-0.5,0.1-1.1,0.7-1.3
                c0.5-0.2,1.1,0.1,1.3,0.6l4.7,14.5C344.5,147.3,344.2,147.8,343.7,148z M356.8,250.3c-2.2,4.7-4.8,9.1-7.9,13.3
                c-0.2,0.3-0.5,0.4-0.8,0.4c-0.2,0-0.4-0.1-0.6-0.2c-0.5-0.3-0.5-1-0.2-1.4c3-4,5.6-8.4,7.7-12.9c0.2-0.5,0.8-0.7,1.3-0.5
                C356.8,249.2,357,249.8,356.8,250.3z M356.6,190.8c-0.2-0.5,0.1-1.1,0.7-1.3c0.5-0.2,1.1,0.1,1.3,0.6l1.6,4.9
                c1.1,3.3,1.9,6.6,2.5,9.9c0.1,0.6-0.3,1.1-0.8,1.2c-0.1,0-0.1,0-0.2,0c-0.5,0-0.9-0.3-1-0.8c-0.6-3.3-1.4-6.5-2.4-9.7L356.6,190.8z
                 M361.8,235.7c-0.1,0.5-0.5,0.8-1,0.8c-0.1,0-0.2,0-0.2,0c-0.5-0.1-0.9-0.7-0.8-1.2c1.1-4.9,1.8-9.9,1.9-14.9c0-0.6,0.5-1,1-1
                c0.6,0,1,0.5,1,1C363.6,225.5,363,230.7,361.8,235.7z`,
      },
    ],
    palette: [
      ["#4C5B99", "#A9B3C9"], // Deep Pink, Steel Blue
      ["#FFA500", "#8A2BE2"], // Orange, Blue Violet
      ["#1E90FF", "#FF4500"], // Dodger Blue, Orange Red
      ["#DC143C", "#40E0D0"], // Crimson, Turquoise
    ],
  },
  {
    id: "shape29",
    selectedpalate: 0,
    data: [
      {
        fill: "#30773A",
        id: "shape29-1",
        d: `M200,0C144.3,0,99.2,22.1,99.2,48.2H21.7c-11.5,0-20.9,9.3-20.9,20.9v167.5C0.8,326.9,90,400,200,400
                s199.2-73.1,199.2-163.4V69.1c0-11.5-9.3-20.8-20.9-20.8h-77.5C300.8,23.1,255.7,0,200,0L200,0z`,
      },
      {
        fill: "#85BA82",
        id: "shape29-2",
        d: `M300.8,70.9h-22.6V48.4c-0.4-1.5-4.7-8-19.6-14.6c-16-7.2-36.9-11.1-58.6-11.1c-23.2,0-45.6,4.4-61.5,12.1
                c-13.6,6.6-16.7,12.7-16.7,13.5v22.6H99.2H23.5v165.7c0,77.6,79.2,140.8,176.5,140.8s176.6-63.1,176.6-140.8V70.9H300.8z
                 M205.4,70.8L200,81.6l-5.4-10.9l-12-1.8l8.7-8.4l-2-11.9l10.7,5.6l10.7-5.6l-2.1,11.9l8.7,8.4L205.4,70.8z`,
      },
    ],
    palette: [
      ["#30773A", "#85BA82"], // Tomato, Royal Blue
      ["#32CD32", "#8B008B"], // Lime Green, Dark Magenta
      ["#FFD700", "#FF4500"], // Gold, Orange Red
      ["#6A5ACD", "#20B2AA"], // Slate Blue, Light Sea Green
    ],
  },
  {
    id: "shape30",
    selectedpalate: 0,
    data: [
      {
        fill: "#923F55",
        id: "shape30-1",
        d: `M391.2,217.7c0-3.4,1.5-6.7,4.4-8.9c2.9-2.2,4.4-5.5,4.4-8.9c0-3.3-1.5-6.6-4.4-8.9c-2.9-2.2-4.4-5.5-4.4-8.9
                c0-2.7,1-5.4,3-7.5c2-2.2,3-4.9,3-7.5c0-4-2.1-7.9-6-9.9c-3.9-2-6-5.9-6-9.9c0-2.1,0.6-4.1,1.8-6c1.2-1.9,1.8-4,1.8-6
                c0-4.7-2.9-9.1-7.8-10.6c-4.8-1.5-7.8-5.9-7.8-10.6c0-1.4,0.3-2.9,0.9-4.3c0.6-1.4,0.9-2.9,0.9-4.3c0-5.4-4-10.3-9.7-11
                c-5.7-0.7-9.7-5.6-9.7-11c0-0.8,0.1-1.7,0.3-2.5c1.6-7-3.8-13.6-10.8-13.6c-0.2,0-0.4,0-0.6,0c-6.4,0.3-11.6-4.8-11.6-11.1
                c0-0.2,0-0.4,0-0.6c0.3-6.5-4.9-11.7-11.1-11.7c-0.8,0-1.6,0.1-2.5,0.3c-0.8,0.2-1.7,0.3-2.5,0.3c-5.5,0-10.3-4.1-11-9.7
                c-0.7-5.8-5.6-9.7-11-9.7c-1.4,0-2.9,0.3-4.3,0.9c-1.4,0.6-2.9,0.9-4.3,0.9c-4.7,0-9.1-3-10.6-7.8c-1.5-4.9-6-7.8-10.6-7.8
                c-2,0-4.1,0.6-6,1.8c-1.9,1.2-4,1.8-6,1.8c-4,0-7.9-2.2-9.9-6c-2-3.9-5.9-6-9.9-6c-2.7,0-5.4,1-7.5,3c-4.8,4.5-12.4,3.8-16.4-1.4
                C206.6,1.5,203.3,0,200,0s-6.6,1.5-8.9,4.4c-2.2,2.9-5.5,4.4-8.9,4.4c-2.7,0-5.4-1-7.5-3c-2.2-2-4.9-3-7.5-3c-4,0-7.9,2.1-9.9,6
                c-2,3.9-5.9,6-9.9,6c-2,0-4.1-0.6-6-1.8c-1.9-1.2-4-1.8-6-1.8c-4.7,0-9.1,2.9-10.6,7.8c-1.5,4.8-5.9,7.8-10.6,7.8
                c-1.4,0-2.9-0.3-4.3-0.9c-1.4-0.6-2.9-0.9-4.3-0.9c-5.4,0-10.3,4-11,9.7c-0.7,5.7-5.5,9.7-11,9.7c-0.8,0-1.7-0.1-2.5-0.3
                c-7-1.6-13.6,3.7-13.6,10.8c0,0.2,0,0.4,0,0.6c0.3,6.4-4.8,11.7-11.1,11.7c-0.2,0-0.4,0-0.5,0c-6.5-0.3-11.7,4.9-11.7,11.1
                c0,0.8,0.1,1.7,0.3,2.5c0.2,0.8,0.3,1.7,0.3,2.5c0,5.5-4.1,10.3-9.7,11c-5.8,0.7-9.7,5.7-9.7,11c0,1.4,0.3,2.9,0.9,4.3
                c0.6,1.4,0.9,2.9,0.9,4.3c0,4.7-3,9.1-7.8,10.6c-4.9,1.5-7.8,6-7.8,10.6c0,2,0.6,4.1,1.8,6c1.2,1.9,1.8,3.9,1.8,6c0,4-2.2,7.9-6,9.9
                c-3.9,2-6,5.9-6,9.9c0,2.7,1,5.4,3,7.5c2,2.1,3,4.9,3,7.5c0,3.4-1.5,6.7-4.4,8.9C1.5,193.4,0,196.7,0,200c0,3.3,1.5,6.6,4.4,8.9
                c2.9,2.2,4.4,5.5,4.4,8.9c0,2.7-1,5.4-3,7.5c-2,2.2-3,4.9-3,7.5c0,4,2.1,7.9,6,9.9c3.9,2,6,5.9,6,9.9c0,2.1-0.6,4.1-1.8,6
                c-1.2,1.9-1.8,4-1.8,6c0,4.7,2.9,9.1,7.8,10.6c4.8,1.5,7.8,5.9,7.8,10.6c0,1.4-0.3,2.9-0.9,4.3c-0.6,1.4-0.9,2.9-0.9,4.3
                c0,5.4,4,10.3,9.7,11c5.7,0.7,9.7,5.5,9.7,11c0,0.8-0.1,1.6-0.3,2.5c-1.6,7,3.7,13.6,10.8,13.6c0.2,0,0.4,0,0.6,0
                c6.4-0.3,11.6,4.8,11.6,11.1c0,0.2,0,0.4,0,0.6c-0.3,6.5,4.9,11.7,11.1,11.7c0.8,0,1.7-0.1,2.5-0.3c0.8-0.2,1.7-0.3,2.5-0.3
                c5.5,0,10.3,4.1,11,9.7c0.7,5.8,5.7,9.7,11,9.7c1.4,0,2.9-0.3,4.3-0.9c1.4-0.6,2.9-0.9,4.3-0.9c4.7,0,9.1,3,10.6,7.8
                c1.5,4.9,6,7.8,10.6,7.8c2,0,4.1-0.6,6-1.8c1.9-1.2,4-1.8,6-1.8c4,0,7.9,2.2,9.9,6c2,3.9,5.9,6,9.9,6c2.7,0,5.4-1,7.5-3
                c2.1-2,4.9-3,7.5-3c3.4,0,6.7,1.5,8.9,4.4c2.2,2.9,5.5,4.4,8.9,4.4s6.6-1.5,8.9-4.4c2.2-2.9,5.5-4.4,8.9-4.4c2.7,0,5.4,1,7.5,3
                c2.2,2,4.9,3,7.5,3c4,0,7.9-2.1,9.9-6c2-3.9,5.9-6,9.9-6c2.1,0,4.2,0.6,6,1.8c1.9,1.2,4,1.8,6,1.8c4.7,0,9.1-3,10.6-7.8
                c1.5-4.8,5.9-7.8,10.6-7.8c1.4,0,2.9,0.3,4.3,0.9s2.9,0.9,4.3,0.9c5.4,0,10.3-4,11-9.7c0.7-5.7,5.5-9.7,11-9.7
                c0.8,0,1.6,0.1,2.5,0.3c7,1.6,13.6-3.7,13.6-10.8c0-0.2,0-0.4,0-0.6c-0.3-6.4,4.8-11.6,11.1-11.6c0.2,0,0.4,0,0.6,0
                c6.5,0.3,11.6-4.9,11.6-11.1c0-0.8-0.1-1.6-0.3-2.5c-0.2-0.8-0.3-1.7-0.3-2.5c0-5.5,4.1-10.3,9.7-11c5.8-0.7,9.7-5.6,9.7-11
                c0-1.4-0.3-2.9-0.9-4.3c-0.6-1.4-0.9-2.9-0.9-4.3c0-4.7,3-9.1,7.8-10.6c4.9-1.5,7.8-6,7.8-10.6c0-2-0.6-4.1-1.8-6
                c-1.2-1.9-1.8-3.9-1.8-6c0-4,2.2-7.9,6-9.9c3.9-2,6-5.9,6-9.9c0-2.7-1-5.4-3-7.5C392.2,223.1,391.2,220.4,391.2,217.7z`,
      },
      {
        fill: "#E09FBF",
        id: "shape30-2",
        d: `M200,21.5c-98.6,0-178.5,79.9-178.5,178.5c0,98.6,79.9,178.5,178.5,178.5S378.5,298.6,378.5,200
                C378.5,101.4,298.6,21.5,200,21.5z M163.7,63.2l-3.2,4.3l-3.2-4.3l-4.3-3.2l4.3-3.2l3.2-4.3l3.2,4.3L168,60L163.7,63.2z M203.4,55.7
                l-3.2,4.3l-3.2-4.3l-4.3-3.2l4.3-3.2l3.2-4.3l3.2,4.3l4.3,3.2L203.4,55.7z M244,64.2l-3.2,4.3l-3.2-4.3l-4.3-3.2l4.3-3.2l3.2-4.3
                l3.2,4.3l4.3,3.2L244,64.2z`,
      },
    ],
    palette: [
      ["#923F55", "#E09FBF"], // Deep Pink, Steel Blue
      ["#FFA500", "#8A2BE2"], // Orange, Blue Violet
      ["#1E90FF", "#FF4500"], // Dodger Blue, Orange Red
      ["#DC143C", "#40E0D0"], // Crimson, Turquoise
    ],
  },
  {
    id: "shape31",
    selectedpalate: 0,
    data: [
      {
        fill: "#8F94AC",
        id: "shape31-1",
        d: `M58.4,58.8C22.3,95,0.1,144.9,0.1,200v0.1c16.9-19.9,30.5-42.2,40.3-66C50.2,110.3,56.4,84.9,58.4,58.8z`,
      },
      {
        fill: "#8F94AC",
        id: "shape31-2",
        d: `M0.1,200.3c0.1,55.1,22.5,105,58.6,141.2c-2.1-26-8.3-51.4-18.2-75.2S17,220.1,0.1,200.3z`,
      },
      {
        fill: "#8F94AC",
        id: "shape31-3",
        d: `M58.5,58.7C110.6,54.5,160,34,199.7,0.1C144.5,0.2,94.7,22.6,58.5,58.7z`,
      },
      {
        fill: "#8F94AC",
        id: "shape31-4",
        d: `M58.9,341.6c36.1,36.1,86,58.3,141.1,58.3h0.1c-19.9-16.9-42.2-30.5-66-40.3
                C110.2,349.8,84.9,343.6,58.9,341.6z`,
      },
      {
        fill: "#8F94AC",
        id: "shape31-5",
        d: `M200,0.1h-0.1c39.8,33.8,89.2,54.2,141.3,58.4C305,22.4,255.1,0.1,200,0.1z`,
      },
      {
        fill: "#8F94AC",
        id: "shape31-6",
        d: `M200.3,399.9c55.1-0.1,105-22.5,141.2-58.6c-26,2.1-51.4,8.3-75.2,18.2C242.4,369.4,220.1,383,200.3,399.9z`,
      },
      {
        fill: "#8F94AC",
        id: "shape31-7",
        d: `M399.9,199.7c-0.1-55.2-22.5-105-58.7-141.2c2.1,26,8.3,51.4,18.2,75.2C369.4,157.6,383,179.8,399.9,199.7z`,
      },
      {
        fill: "#8F94AC",
        id: "shape31-8",
        d: `M341.6,341.2c36-36.2,58.3-86.1,58.3-141.2v-0.1c-16.9,19.9-30.5,42.2-40.3,66
                C349.8,289.8,343.6,315.1,341.6,341.2z`,
      },
      {
        fill: "#BECAD8",
        id: "shape31-9",
        d: `M399.9,199.7v0.2c-16.9,19.9-30.5,42.2-40.3,66c-9.8,23.9-16,49.2-18,75.3l-0.1,0.1c-26,2.1-51.4,8.3-75.2,18.2
              c-23.8,9.9-46.1,23.5-66,40.5h-0.1c-19.9-16.9-42.2-30.5-66.1-40.3c-23.8-9.8-49.2-16-75.2-18c-0.1-0.1-0.1-0.1-0.2-0.1
              c-2.1-26-8.3-51.4-18.2-75.2s-23.5-46.1-40.5-66v-0.1c16.9-19.9,30.5-42.2,40.3-66.1s16-49.2,18-75.2c0,0,0.1-0.1,0.1-0.1
              C110.6,54.5,160,34,199.7,0.1h0.2c39.8,33.8,89.2,54.2,141.3,58.4c0,0,0.1,0,0.1,0.1c2.1,26,8.3,51.4,18.2,75.2
              C369.4,157.6,383,179.9,399.9,199.7z`,
      },
      {
        fill: "#8F94AC",
        id: "shape31-10",
        d: `M200.7,354.2c-84.8,0-153.9-69-153.9-153.9s69-153.9,153.9-153.9s153.9,69,153.9,153.9S285.5,354.2,200.7,354.2
              z M200.7,48.5c-83.7,0-151.8,68.1-151.8,151.8S117,352,200.7,352S352.5,284,352.5,200.3S284.4,48.5,200.7,48.5z`,
      },
    ],
    palette: [
      // Red-themed palette
      ["#8F94AC", "#8F94AC", "#8F94AC", "#8F94AC", "#8F94AC", "#8F94AC", "#8F94AC", "#8F94AC", "#BECAD8", "#8F94AC"],

      // Yellow-themed palette
      ["#B89F4E", "#B89F4E", "#B89F4E", "#B89F4E", "#B89F4E", "#B89F4E", "#B89F4E", "#B89F4E", "#E6D27D", "#B89F4E"],

      // Blue-themed palette
      ["#3E5F8A", "#3E5F8A", "#3E5F8A", "#3E5F8A", "#3E5F8A", "#3E5F8A", "#3E5F8A", "#3E5F8A", "#6D9DC5", "#3E5F8A"],

      // Orange-themed palette
      ["#B86530", "#B86530", "#B86530", "#B86530", "#B86530", "#B86530", "#B86530", "#B86530", "#E69A62", "#B86530"],
    ],
  },
  {
    id: "shape32",
    selectedpalate: 0,
    data: [
      {
        fill: "#E8F3F5",
        id: "shape32-1",
        d: `M61.6,13v249.4c0,68.9,62,124.7,138.4,124.7c76.4,0,138.4-55.8,138.4-124.7V13H61.6z`,
      },
      {
        fill: "#8DB5C2",
        id: "shape32-2",
        d: `M200,400c-83.5,0-151.4-61.8-151.4-137.7V13c0-7.2,5.8-13,13-13h276.8c7.2,0,13,5.8,13,13v249.4
            C351.4,338.3,283.5,400,200,400z M74.6,25.9v236.4C74.6,323.9,130.8,374,200,374s125.4-50.1,125.4-111.7V25.9H74.6z`,
      },
    ],
    palette: [
      ["#E8F3F5", "#8DB5C2"], // Orange Red, Slate Blue
      ["#32CD32", "#8A2BE2"], // Lime Green, Blue Violet
      ["#1E90FF", "#FF6347"], // Dodger Blue, Tomato
      ["#DC143C", "#4682B4"], // Crimson, Steel Blue
    ],
  },
  {
    id: "shape33",
    selectedpalate: 0,
    data: [
      {
        fill: "#F3E8E8",
        id: "shape33-1",
        d: `M199.889,375.189c-4.499,0-8.003-2.176-8.974-2.844l-0.906-0.404L56.517,294.736l-1.452-1.052
                c-1.062-0.506-4.7-2.454-6.948-6.35c-1.12-1.938-1.637-4.157-1.882-5.927l-0.033-6.074L46.12,122.795l0.093-0.905
                c-0.093-1.173-0.226-5.298,2.024-9.193c2.148-3.721,6.329-6.085,6.799-6.343l13.45-8.062l1.28-1.007l120.018-69.173l1.132-0.507
                c0.971-0.666,4.475-2.844,8.974-2.844c3.106,0,6.111,1.269,7.721,2.08l3.955,2.198l134.856,77.764
                c1.537,1.066,3.779,2.898,5.176,5.317c2.249,3.896,2.116,8.019,2.023,9.192l0.303,2.939l-0.112,155.041
                c-0.018,1.372-0.234,5.396-2.094,8.618c-0.75,1.3-1.658,2.364-2.571,3.25l-7.02,4.224l-133.769,77.331
                C207.128,373.402,203.575,375.189,199.889,375.189z`,
      },
      {
        fill: "#944050",
        id: "shape33-2",
        d: `M375.426,113.098l-0.123-4.265c0.015-0.533,0.059-5.331-2.092-9.052c-2.247-3.902-5.89-5.848-6.953-6.35
                L222.152,10.334l-13.707-7.618C207.987,2.438,203.849,0,199.553,0c-4.499,0-8.003,2.178-8.974,2.844L37.066,91.323l-3.631,2.236
                c-0.467,0.259-4.646,2.622-6.792,6.344c-2.253,3.899-2.122,8.023-2.025,9.195L24.708,275.4l0.074,13.299
                c-0.026,0.672-0.173,6.709,2.295,11.51c2.246,3.896,5.881,5.841,6.948,6.349l153.384,88.709l3.748,2.022
                c0.462,0.28,4.592,2.711,8.892,2.711h0.012c4.497,0,7.996-2.179,8.965-2.84l144.022-83.259l13.425-8.08
                c0.472-0.26,4.651-2.622,6.806-6.347c2.246-3.892,2.111-8.017,2.019-9.192L375.426,113.098z M199.889,375.189
                c-4.499,0-8.003-2.176-8.974-2.844l-0.906-0.404L56.517,294.736l-1.452-1.052c-1.062-0.506-4.7-2.454-6.948-6.35
                c-1.12-1.938-1.637-4.157-1.882-5.927l-0.033-6.074L46.12,122.795l0.093-0.905c-0.093-1.173-0.226-5.298,2.024-9.193
                c2.148-3.721,6.329-6.085,6.799-6.343l13.45-8.062l1.28-1.007l120.018-69.173l1.132-0.507c0.971-0.666,4.475-2.844,8.974-2.844
                c3.106,0,6.111,1.269,7.721,2.08l3.955,2.198l134.856,77.764c1.537,1.066,3.779,2.898,5.176,5.317
                c2.249,3.896,2.116,8.019,2.023,9.192l0.303,2.939l-0.112,155.041c-0.018,1.372-0.234,5.396-2.094,8.618
                c-0.75,1.3-1.658,2.364-2.571,3.25l-7.02,4.224l-133.769,77.331C207.128,373.402,203.575,375.189,199.889,375.189z`,
      },
    ],
    palette: [
      ["#F3E8E8", "#944050"],
      ["#B89F4E", "#E6D27D"],
      ["#3E5F8A", "#6D9DC5"],
      ["#B86530", "#E69A62"],
    ],
  },
  {
    id: "shape34",
    selectedpalate: 0,
    data: [
      {
        fill: "#F3E8E8",
        id: "shape34-1",
        d: `M 65.1511,44.7604L 326.56,45.7605L 327.954,316.298L 199.2,386.808L 65.012,317.798L 65.1511,44.7604 Z`,
      },
      {
        fill: "#DCDEDC",
        id: "shape34-2",
        d: `M 170.833,39.6897L 225.266,39.906L 225.256,79.7416L 197.585,98.4109L 171.144,80.4919L 170.864,39.6896`,
      },
      {
        fill: "#F2F3F2",
        id: "shape34-3",
        d: `M 321.039,50.897L 322.485,313.015L 199.197,380.618L 70.4323,314.436L 321.039,50.897 Z`,
      },
      {
        fill: "#FF492C",
        id: "shape34-4",
        d: `M 30.2493,222.181L 366.619,222.181L 377.953,244.686L 366.118,269.023L 30.2222,269.023L 17.5553,245.019L 30.2493,222.181 Z`,
      },
    ],
    palette: [
      ["#F3E8E8", "#DCDEDC", "#F2F3F2", "#FF492C"],
      ["#3498DB", "#2ECC71", "#F1C40F", "#E74C3C"],
      ["#8E44AD", "#1ABC9C", "#D35400", "#2C3E50"],
      ["#B86530", "#E69A62", "#D37C42", "#F4B88E"],
    ],
  },
  {
    id: "shape35",
    selectedpalate: 0,
    data: [
      {
        fill: "#FFFFFF",
        id: "shape35-1",
        d: `M 70.6738,64.4056L 315.52,63.6798L 365.064,142.336L 365.773,152.03L 204.813,350.79L 183.361,350.295L 21.7413,151.715L 21.6238,141.775L 70.5838,64.4356`,
      },
      {
        fill: "#5B745B",
        id: "shape35-2",
        d: `M 76.6343,76.4327L 311.354,76.0727L 354.234,144.993L 353.994,149.193L 200.554,338.713L 187.354,338.713L 34.1543,150.313L 32.7143,144.073L 76.6343,76.4327 Z`,
      },
    ],
    palette: [
      ["#FFFFFF", "#5B745B"],
      ["#3498DB", "#2ECC71"],
      ["#8E44AD", "#1ABC9C"],
      ["#D35400", "#2C3E50"],
    ],
  },
  {
    id: "shape36",
    selectedpalate: 0,
    data: [
      {
        fill: "#00FF00",
        id: "shape36-1",
        d: `M200 50 L244 150 L350 160 L265 230 L290 340 L200 280 L110 340 L135 230 L50 160 L156 150 Z`,
      },
    ],

    palette: [["#00FF00"], ["#E74C3C"], ["#2C3E50"], ["#F4B88E"]],
  },
  {
    id: "shape37",
    selectedpalate: 0,
    data: [
      {
        fill: "#DC143C",
        id: "shape37-1",
        d: `M200,50 A150,150 0 1,1 199.99,50 Z`,
      },
    ],
    palette: [
      ["#DC143C"],
      ["#32CD32"], // Lime Green, Blue Violet
      ["#1E90FF"], // Dodger Blue, Tomato
      ["#E8F3F5"], // Orange Red, Slate Blue
    ], // Crimson, Steel Blue],
  },
]
